/*
  TRIDOS custom scripts — register item 039 (docs/CUSTOMIZATIONS.md).
  Loaded once from layout/theme.liquid, right after theme.js. Archetype never ships
  this file, so a Streamline update cannot overwrite it. Every block below carries the
  register number it belongs to. Keep the blocks in register order.

  Every block runs inside tridosBlock(): the file is one script, so without it one
  throw in an early block (a missing element, an old browser) would stop every block
  after it — the currency picker included. Errors are logged, not swallowed.
*/
function tridosBlock(name, fn) {
  try {
    fn();
  } catch (err) {
    if (window.console && console.error) console.error('[custom.js ' + name + ']', err);
  }
}

/* theme.js fires 'variantChange' on the product section (it does not bubble) with the
   chosen variant — or null when the option combination does not exist. One capturing
   listener on document hears it for every section, including a quick-shop section
   loaded over AJAX later (a capturing ancestor listener fires for non-bubbling events
   too). Blocks register handlers with tridosOnVariantChange(); they run in the order
   registered, which is file order — 042 relies on running after 039. A throwing handler
   does not stop the next one. */
var tridosVariantHandlers = [];
function tridosOnVariantChange(name, fn) {
  tridosVariantHandlers.push({ name: name, fn: fn });
}
document.addEventListener('variantChange', function (event) {
  var section = event.target;
  if (!section || !section.querySelector) return;
  var variant = event.detail && event.detail.variant;
  tridosVariantHandlers.forEach(function (h) {
    try {
      h.fn(section, variant);
    } catch (err) {
      if (window.console && console.error) console.error('[custom.js ' + h.name + ' variantChange]', err);
    }
  });
}, true);

/* 039 — Stock + delivery in one row (snippets/product-inventory.liquid).
   Keeps the row true when the shopper picks another variant: the words, the dot
   colour, the "Back in stock <date>" note and the "Notify me" link. theme.js is not
   involved — its hook ([data-product-inventory]) is absent from our markup on purpose,
   because it hides the row when a variant is sold out and we want "Sold out" shown.
   The delivery part of the row is the TRIDOS OS widget; it watches the variant itself.

   "Notify me when it is back" opens the restock app's own form (Stoq, an app embed,
   formerly "Restock Rocket" — hence its class names). Stoq draws a second full-width
   button under "Sold Out"; assets/custom.css hides it wherever this row exists (the
   <html> class set below) and the link stands in. Stoq exposes
   window._Stoq.openModal(); if that ever goes, the link falls back to clicking the
   hidden button. The link is rendered only in the main product section — in the
   quick-shop pop-up Stoq's form would open for the wrong product. */
tridosBlock('039', function () {
  'use strict';

  var ROW = '[data-tridos-stock]';
  var HIDDEN = 'hide';

  function stoqReady() {
    return (window._Stoq && typeof window._Stoq.openModal === 'function') ||
      !!document.querySelector('.restock-rocket-button');
  }

  function openStoq(event) {
    event.preventDefault();
    if (window._Stoq && typeof window._Stoq.openModal === 'function') {
      window._Stoq.openModal();
      return;
    }
    var button = document.querySelector('.restock-rocket-button');
    if (button) button.click();
  }

  function rows() {
    return Array.prototype.slice.call(document.querySelectorAll(ROW));
  }

  function inventoryFor(row, variant) {
    var all = window.inventories && window.inventories[row.getAttribute('data-product-id')];
    return (all && all[variant.id]) || null;
  }

  /* A row that is sold out with no restock date wants the link; whether it shows
     depends on Stoq having loaded, which happens after us. A discontinued product
     (data-discontinued, register 044) never does: it will not come back. */
  function wantsNotify(row) {
    var extra = row.querySelector('.tridos-stock__extra');
    return row.classList.contains('inventory--out') && !!extra && extra.hidden &&
      !row.hasAttribute('data-discontinued');
  }

  function syncNotify(row) {
    var notify = row.querySelector('.tridos-stock__notify');
    if (notify) notify.hidden = !(wantsNotify(row) && stoqReady());
  }

  function render(row, variant) {
    var item = row.closest('.sales-point');
    if (!variant) {
      // No such variant for this option combination: nothing true to say.
      if (item) item.classList.add(HIDDEN);
      return;
    }
    if (item) item.classList.remove(HIDDEN);
    var label = row.querySelector('.tridos-stock__label');
    var extra = row.querySelector('.tridos-stock__extra');
    var extraText = row.querySelector('.tridos-stock__extra-text');
    if (!label || !extra || !extraText) return;

    var inv = inventoryFor(row, variant);
    var qty = inv ? parseInt(inv.quantity, 10) : NaN;
    var threshold = parseInt(row.getAttribute('data-threshold'), 10);
    if (isNaN(threshold)) threshold = 10; // same fallback as the Liquid `default: 10`; 0 is a real value
    var tracked = variant.inventory_management === 'shopify';
    var physical = variant.requires_shipping !== false;

    var state = 'in';
    var text = row.getAttribute('data-label-in');
    var extraStr = '';

    if (!variant.available) {
      state = 'out';
      text = row.getAttribute('data-label-out');
      var transfers = row.getAttribute('data-transfers') === 'true';
      if (transfers && inv && inv.incoming && inv.next_incoming_date) {
        extraStr = row.getAttribute('data-label-back').replace('[date]', inv.next_incoming_date);
      }
    } else if (tracked && physical && qty <= 0) {
      state = 'low';
      text = row.getAttribute('data-label-backorder');
    } else if (tracked && physical && qty > 0 && qty <= threshold) {
      state = 'low';
      text = row.getAttribute(qty === 1 ? 'data-label-one' : 'data-label-other').replace('[count]', qty);
    }

    // 042: the fallback words follow the variant — a licence is "Delivered by email",
    // never "Ships worldwide from EU". The widget reads the attribute when it needs it.
    var mount = row.querySelector('#tridos-dp');
    if (mount) {
      mount.setAttribute('data-fallback',
        mount.getAttribute(physical ? 'data-fallback-physical' : 'data-fallback-digital') || '');
    }

    row.classList.remove('inventory--low', 'inventory--out');
    if (state === 'low') row.classList.add('inventory--low');
    if (state === 'out') row.classList.add('inventory--out');
    // 042: may a delivery date (or its fallback) follow these words? Not when sold out
    // or backordered — the same test as the snippet's dp_ready / the widget's data-stock.
    var dated = state === 'in' || (state === 'low' && qty > 0);
    row.setAttribute('data-tridos-dated', dated ? 'true' : 'false');
    label.textContent = text;
    extraText.textContent = extraStr;
    extra.hidden = !extraStr;
    syncNotify(row);
  }

  // Every row in the section that fired follows the new variant.
  tridosOnVariantChange('039', function (section, variant) {
    Array.prototype.forEach.call(section.querySelectorAll(ROW), function (row) {
      render(row, variant);
    });
  });

  function init() {
    // The CSS that hides Stoq's own button keys on this class, so a product template
    // without this row (no Inventory status block) keeps Stoq's button.
    var notify = document.querySelector(ROW + ' .tridos-stock__notify');
    if (!notify) return;
    document.documentElement.classList.add('tridos-has-stock-row');
    rows().forEach(syncNotify);
    // Stoq's markup lands after us; the link may show only once it has. Watch the page
    // until then, and stop — the callback is one querySelector, and it runs only on
    // pages that have the link at all.
    if (stoqReady() || !window.MutationObserver) return;
    var observer = new MutationObserver(function () {
      if (!stoqReady()) return;
      observer.disconnect();
      rows().forEach(syncNotify);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.tridos-stock__notify-link');
    if (link) openStoq(event);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
});

/* 022 + 044 — The buy button's words after a variant change (snippets/product-form.liquid).
   theme.js rewrites the button on every variant change: "Add to cart" when the variant
   is available, "Sold Out" when it is not. Two TRIDOS cases override that, after
   theme.js has run (setTimeout 0):
   - 022: a product tagged "_label_Coming Soon" always says "Coming Soon" and stays
     disabled, whatever the variant's stock (it cannot be bought yet).
   - 044: a discontinued product's sold-out variant says "Discontinued", not "Sold Out".
   The words come from the locale through data attributes the snippet renders. Own block,
   so it works on a template without the stock row too. */
tridosBlock('022/044', function () {
  'use strict';

  tridosOnVariantChange('022/044', function (section, variant) {
    var text = section.querySelector('[data-add-to-cart-text]');
    if (!text) return;
    var comingSoon = text.getAttribute('data-coming-soon-text');
    var discontinued = text.getAttribute('data-discontinued-text');
    if (!comingSoon && !discontinued) return;
    setTimeout(function () {
      var button = text.closest('button');
      if (comingSoon) {
        text.textContent = comingSoon;
        if (button) button.disabled = true;
      } else if (variant && !variant.available) {
        text.textContent = discontinued;
      }
    }, 0);
  });
});

/* 042 — Delivery estimate: the fallback line when the widget never answers
   (snippets/product-inventory.liquid, assets/custom.css block 042).
   The snippet draws a "still loading" bar (.tdp-ph) inside the widget mount; the
   widget (os.tridos.lv/api/dp/widget.js) replaces it with the sentence, or with the
   fallback line itself when its request fails. This block covers the case where the
   widget never runs at all — the script blocked or lost on a bad connection: after 8 s
   (or at once, when the script tag reports it could not load) the mount becomes
   "· Ships worldwide from EU", the words the snippet put in data-fallback, and this
   block owns the mount from then on: every variant change redraws it (the words follow
   the variant — "Delivered by email" for a licence; nothing for a sold-out or
   backordered variant, which shows no date either). Same markup as the widget's own
   fallback (.tdp-msg.tdp-fallback), so the shopper cannot tell which side gave up.
   The script tag marks <html data-tridos-dp-loaded> when the widget did arrive; from
   that moment the widget owns the mount and this block never touches it again. */
tridosBlock('042', function () {
  'use strict';

  var MOUNT = '#tridos-dp';
  var GIVE_UP_MS = 8000;
  var OWNED = 'data-tridos-dp-fallback';

  function widgetLoaded() {
    return document.documentElement.hasAttribute('data-tridos-dp-loaded');
  }

  function draw(mount, once) {
    if (widgetLoaded() && !once) return;
    var row = mount.closest('[data-tridos-stock]');
    var text = mount.getAttribute('data-fallback') || '';
    mount.innerHTML = '';
    // Out of stock or backordered (data-tridos-dated="false", set by the snippet and
    // kept true by 039): no date would show for it, so no words either.
    if (!text || (row && row.getAttribute('data-tridos-dated') === 'false')) return;
    var sep = document.createElement('span');
    sep.className = 'tdp-sep';
    sep.setAttribute('aria-hidden', 'true');
    sep.textContent = '·';
    var msg = document.createElement('span');
    msg.className = 'tdp-msg tdp-fallback';
    msg.textContent = text;
    mount.appendChild(sep);
    mount.appendChild(msg);
  }

  function giveUp() {
    var mount = document.querySelector(MOUNT);
    if (!mount || mount.hasAttribute(OWNED)) return;
    if (!widgetLoaded()) {
      // The widget never arrived: this block owns the mount from now on.
      mount.setAttribute(OWNED, '');
      draw(mount);
      return;
    }
    // The widget arrived but its estimate request has not settled after 8 s (a stalled
    // connection, a cold start): replace the bar once. The widget keeps the mount and
    // overwrites this the moment it answers.
    if (mount.querySelector('.tdp-ph')) draw(mount, true);
  }

  document.addEventListener('tridos:dp-script-failed', giveUp);
  setTimeout(giveUp, GIVE_UP_MS);

  // Runs after 039 has updated the row's state and data-fallback for the new variant.
  tridosOnVariantChange('042', function (section) {
    var mount = section.querySelector(MOUNT + '[' + OWNED + ']');
    if (mount) draw(mount);
  });
});

/* 040 — Review stars on the vendor line (assets/custom.css block 040).
   Moves the Judge.me preview badge out of its app block and into the vendor line, after a
   middle dot. Judge.me finds its badge by class wherever it sits, so the move can happen
   before the app has drawn the stars; the CSS hides the separator until stars exist. */
tridosBlock('040', function () {
  'use strict';

  function move() {
    var sections = document.querySelectorAll('.product-section:not([data-modal="true"])');
    Array.prototype.forEach.call(sections, function (section) {
      var vendor = section.querySelector('.product-single__vendor');
      var block = section.querySelector('[data-product-blocks] > [id*="judge_me_reviews_preview_badge"]');
      var widget = block && block.querySelector('.jdgm-widget');
      if (!vendor || !widget || block.classList.contains('tridos-badge-moved')) return;
      var sep = document.createElement('span');
      sep.className = 'tridos-vendor__sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '·';
      vendor.appendChild(sep);
      vendor.appendChild(widget);
      block.classList.add('tridos-badge-moved');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move);
  else move();
});

/* 045 — YouTube links become tap-to-play videos (snippets/custom-youtube-embeds.liquid).
   A tap on the thumbnail swaps it for the YouTube player (privacy-enhanced domain,
   autoplay on, start time kept) and moves keyboard focus into the player, so a Tab
   key user is not thrown back to the top of the page. Another video already playing
   in the same dropdown is put back to its thumbnail first (one sound at a time).
   Closing the dropdown that holds a playing video puts the thumbnail back, which
   stops the sound. */
tridosBlock('045', function () {
  'use strict';

  var PLAY = '.tridos-yt__play';

  document.addEventListener('click', function (evt) {
    var button = evt.target.closest && evt.target.closest(PLAY);
    if (!button) return;
    var id = button.getAttribute('data-yt-id');
    if (!/^[\w-]{11}$/.test(id || '')) return;
    var panel = button.closest('.collapsible-content__inner, .rte');
    if (panel) stop(panel);
    var start = parseInt(button.getAttribute('data-yt-start') || '0', 10);
    var frame = document.createElement('iframe');
    frame.className = 'tridos-yt__frame';
    frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1' + (start > 0 ? '&start=' + start : '');
    frame.title = button.getAttribute('aria-label') || 'YouTube video';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame._tridosButton = button;
    frame.tabIndex = 0;
    button.replaceWith(frame);
    try { frame.focus(); } catch (err) {}
  });

  // Runs after theme.js has toggled the dropdown (its listener sits on the button itself).
  // Puts the thumbnails back inside `root`, which stops any video playing there.
  // Block 046 calls it for rows the search hides.
  function stop(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.tridos-yt__frame'), function (frame) {
      if (frame._tridosButton) frame.replaceWith(frame._tridosButton);
    });
  }
  window.tridosStopVideos = stop;

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest && evt.target.closest('.collapsible-trigger');
    if (!trigger || trigger.classList.contains('is-open')) return;
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (panel) stop(panel);
  });
});

/* 046 — Instructions page built from the products (sections/custom-instructions-index.liquid).
   Search box and platform buttons. An item shows when it has the selected platform tag
   and every typed word appears in its title, tags, type or instruction text. The text is
   read once from the rendered row (not a second copy in the HTML), minus the "View
   product" link every row carries, so those words match nothing. A row the filter
   hides has its video stopped (block 045). ?q=<words> and ?platform=<tag> in the URL
   set both on load. The count's words ("12 of 96 products") come from the locale through
   data attributes on the count element. */
tridosBlock('046', function () {
  'use strict';

  function searchText(item) {
    var text = item.textContent;
    var link = item.querySelector('.tridos-instr__product');
    if (link) {
      var linkText = link.textContent;
      var at = text.lastIndexOf(linkText);
      if (at > -1) text = text.slice(0, at) + text.slice(at + linkText.length);
    }
    return ((item.getAttribute('data-search') || '') + ' ' + text).replace(/\s+/g, ' ').toLowerCase();
  }

  function setup(root) {
    var input = root.querySelector('[data-tridos-instr-search]');
    var chips = root.querySelectorAll('[data-tridos-instr-chip]');
    var items = root.querySelectorAll('[data-tridos-instr-item]');
    var count = root.querySelector('[data-tridos-instr-count]');
    var empty = root.querySelector('[data-tridos-instr-empty]');
    if (!input || !count || !empty) return;
    var platform = '';
    var texts = Array.prototype.map.call(items, searchText);

    function apply() {
      var words = (input.value || '').toLowerCase().split(/\s+/).filter(Boolean);
      var shown = 0;
      Array.prototype.forEach.call(items, function (item, n) {
        var text = texts[n];
        var ok = !platform || (item.getAttribute('data-platforms') || '').indexOf('|' + platform + '|') !== -1;
        for (var i = 0; ok && i < words.length; i++) ok = text.indexOf(words[i]) !== -1;
        if (!ok && !item.hidden && window.tridosStopVideos) window.tridosStopVideos(item);
        item.hidden = !ok;
        if (ok) shown++;
      });
      var total = count.getAttribute('data-total');
      var all = count.getAttribute('data-text-all') || total + ' products';
      var some = count.getAttribute('data-text-some') || '[shown] of [total] products';
      count.textContent = shown === +total ? all : some.replace('[shown]', shown).replace('[total]', total);
      empty.hidden = shown !== 0;
    }

    function pick(key) {
      var found = false;
      Array.prototype.forEach.call(chips, function (chip) {
        var on = chip.getAttribute('data-tridos-instr-chip') === key;
        if (on) found = true;
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      // An unknown ?platform= falls back to "All" — once; with no "All" chip, to nothing.
      if (!found && key !== '') return pick('');
      platform = found ? key : '';
      apply();
    }

    Array.prototype.forEach.call(chips, function (chip) {
      chip.addEventListener('click', function () { pick(chip.getAttribute('data-tridos-instr-chip')); });
    });
    input.addEventListener('input', apply);

    var params = new URLSearchParams(window.location.search);
    if (params.get('q')) input.value = params.get('q');
    pick((params.get('platform') || '').toLowerCase());
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tridos-instr]'), setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
});

/* 047 — Display-only currency picker (snippets/tridos-currency.liquid, custom.css block 047).
   The shop sells in EUR only (no Shopify Payments), so this changes what people SEE, never
   what they pay. It rewrites every "€123.45" text on the page into the chosen currency,
   rounded (see money()), and keeps the euro original to put back. A MutationObserver
   catches prices drawn later (variant change, quick shop, bundle card, offer bar).
   Not converted: the sticky checkout bar total (#StickySubtotal, it sits beside the
   Checkout button and shows what will be charged), and our own notes ([data-cx-keep]).
   Under the product price and the cart subtotal a grey note says what is paid in EUR.

   Rates: European Central Bank rates from TRIDOS OS (os.tridos.lv/api/fx, the host the
   delivery estimate already uses; tridos-os docs/apps/fx.md), fetched only when a
   non-euro currency is in use, cached 12 h; a cache up to 7 days old is used if the
   service is down; with no rates at all the page stays in EUR.
   First visit: the currency follows the visitor's country (Shopify's
   /browsing_context_suggestions.json). A visitor's own choice always wins after that.
   The note's words come from the locale through data attributes on the header switch
   (data-cx-i18n); the English below is only the fallback. */
tridosBlock('047', function () {
  'use strict';

  var KEY = 'tridos_cx';
  var RATES_KEY = 'tridos_cx_rates';
  var RATES_URL = 'https://os.tridos.lv/api/fx?symbols=';
  var FRESH_MS = 12 * 3600 * 1000;
  var STALE_MS = 7 * 24 * 3600 * 1000;
  var COUNTRY = { US: 'USD', PR: 'USD', GU: 'USD', VI: 'USD', AS: 'USD', MP: 'USD',
    GB: 'GBP', GG: 'GBP', JE: 'GBP', IM: 'GBP', CA: 'CAD', HU: 'HUF', PL: 'PLN', SE: 'SEK',
    DK: 'DKK', GL: 'DKK', FO: 'DKK', CZ: 'CZK', RO: 'RON' };
  // "€1,234.56" / "€149" (+ optional " EUR"). A comma-decimal "€12,50" is left alone
  // rather than half-read as "€12".
  var PRICE = /€\s?(\d{1,3}(?:,\d{3})+(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)(?!\d|[.,]\d)(\s?EUR\b)?/g;
  var SKIP = 'script,style,noscript,textarea,[data-cx-keep],#StickySubtotal';
  var PRODUCT_PRICES = '[data-section-type="product-template"] .product-single__prices';

  var options = document.querySelectorAll('[data-cx-option]');
  if (!options.length || !window.fetch || !window.Map) return;

  var codes = [];
  var plural = {};
  var flagSrc = {};
  Array.prototype.forEach.call(options, function (o) {
    var c = o.getAttribute('data-cx-option');
    if (codes.indexOf(c) === -1) codes.push(c);
    plural[c] = o.getAttribute('data-plural');
    flagSrc[c] = o.getAttribute('data-flag-src');
  });

  function load(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function each(sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); }

  var cur = 'EUR';
  var rates = null;
  var ratesPromise = null;
  var formatters = {};
  var tracked = new Map(); // text node -> { orig: euro text, shown: converted text }

  function covers(r) {
    return !!r && codes.every(function (c) { return c === 'EUR' || typeof r[c] === 'number'; });
  }

  function loadRates() {
    if (ratesPromise) return ratesPromise;
    var cached = load(RATES_KEY);
    var age = cached && cached.t ? Date.now() - cached.t : Infinity;
    if (covers(cached && cached.rates) && age < FRESH_MS) {
      ratesPromise = Promise.resolve(cached.rates);
      return ratesPromise;
    }
    ratesPromise = fetch(RATES_URL + codes.filter(function (c) { return c !== 'EUR'; }).join(','))
      .then(function (r) { if (!r.ok) throw new Error('rates ' + r.status); return r.json(); })
      .then(function (d) {
        var fresh = d && d.rates;
        if (fresh) fresh.EUR = 1;
        // Same test the cached copy gets: a service answer missing one of our
        // currencies would otherwise print "RON NaN" on every price.
        if (!covers(fresh)) throw new Error('rates incomplete');
        save(RATES_KEY, { t: Date.now(), date: d.date, rates: fresh });
        return fresh;
      })
      .catch(function (err) {
        if (covers(cached && cached.rates) && age < STALE_MS) return cached.rates;
        ratesPromise = null;
        throw err;
      });
    return ratesPromise;
  }

  // Under €10 one decimal ("$2.3"), from €10 whole units ("$169"). Mikus 2026-09-29:
  // whole units alone were up to 17 % off on the €2 parts (£1.71 shown as £2).
  // Currencies where €1 buys more than 20 units (HUF, CZK) are always whole: "HUF 787.5"
  // for €2 would be noise, and a whole unit is under 1 % of the smallest price.
  function money(eur, code) {
    var rate = code === 'EUR' ? 1 : rates[code];
    var digits = Math.abs(eur) < 10 && rate < 20 ? 1 : 0;
    var key = code + digits;
    var f = formatters[key] || (formatters[key] = new Intl.NumberFormat('en-US', {
      style: 'currency', currency: code, minimumFractionDigits: digits, maximumFractionDigits: digits }));
    return f.format(eur * rate);
  }

  function eurOf(amount) { return parseFloat(amount.replace(/,/g, '')); }

  function allowed(node) {
    var p = node.parentElement;
    return !!p && !p.closest(SKIP);
  }

  function convertNode(node) {
    var rec = tracked.get(node);
    var text = node.nodeValue;
    if (rec && text === rec.shown) return;
    PRICE.lastIndex = 0;
    if (!PRICE.test(text)) { tracked.delete(node); return; }
    var shown = text.replace(PRICE, function (m, amount, suffix) {
      return money(eurOf(amount), cur) + (suffix ? ' ' + cur : '');
    });
    tracked.set(node, { orig: text, shown: shown });
    node.nodeValue = shown;
  }

  function walk(root) {
    if (root.nodeType === 3) {
      if (root.nodeValue.indexOf('€') > -1 && allowed(root)) convertNode(root);
      return;
    }
    if (root.nodeType !== 1 || root.closest(SKIP)) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (n.nodeValue.indexOf('€') > -1 && allowed(n)) convertNode(n);
    }
  }

  var observer = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.type === 'characterData') walk(m.target);
      else Array.prototype.forEach.call(m.addedNodes, walk);
    });
    if (tracked.size > 300) tracked.forEach(function (rec, node) { if (!node.isConnected) tracked.delete(node); });
    refreshNotes();
  });

  // The euro text an element showed before we touched it, e.g. "€149.00".
  function euroText(el) {
    var out = '';
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var rec = tracked.get(n);
      out += rec && n.nodeValue === rec.shown ? rec.orig : n.nodeValue;
    }
    PRICE.lastIndex = 0;
    var m = PRICE.exec(out);
    return m ? m[0].replace(/\s?EUR$/, '') : '';
  }

  // Locale words, rendered by the snippet; English fallbacks if the header is not there.
  var i18nEl = document.querySelector('[data-cx-i18n]');
  function i18n(name, fallback) {
    return (i18nEl && i18nEl.getAttribute('data-' + name)) || fallback;
  }
  var T_PRICE = i18n('approx-price', 'Approximate price in [currency].');
  var T_TOTAL = i18n('approx-total', 'Approximate total in [currency].');
  var T_PAY = i18n('you-pay', 'You pay <b>[amount]</b> (EUR) at checkout.');

  function setNote(anchor, cls, lead, eur) {
    if (!eur) return;
    var el = anchor.nextElementSibling;
    if (!el || !el.classList.contains(cls)) {
      el = document.createElement('p');
      el.className = 'cx-note ' + cls;
      el.setAttribute('data-cx-keep', '');
      anchor.parentNode.insertBefore(el, anchor.nextSibling);
    }
    // `eur` is euro text the PRICE regex matched (digits and punctuation only), and the
    // plural comes from our own markup, so this innerHTML carries no shopper input.
    var html = lead.replace('[currency]', plural[cur]) + ' ' + T_PAY.replace('[amount]', eur);
    if (el.innerHTML !== html) el.innerHTML = html;
  }

  // Product page: under the price. Cart page AND the cart drawer: under the subtotal
  // (both use .cart__item-row [data-subtotal]).
  function refreshNotes() {
    if (cur === 'EUR') {
      each('.cx-note[data-cx-keep]', function (el) { el.remove(); });
      return;
    }
    each(PRODUCT_PRICES, function (box) {
      var price = box.querySelector('[data-product-price]');
      if (price) setNote(box, 'cx-note--product', T_PRICE, euroText(price));
    });
    each('.cart__item-row [data-subtotal]', function (sub) {
      setNote(sub.closest('.cart__item-row'), 'cx-note--cart', T_TOTAL, euroText(sub));
    });
  }

  function restore() {
    observer.disconnect();
    tracked.forEach(function (rec, node) {
      if (node.isConnected && node.nodeValue === rec.shown) node.nodeValue = rec.orig;
    });
    tracked.clear();
  }

  function labels() {
    var sym = cur === 'EUR' ? '€' : money(0, cur).replace(/[\d\s.,]/g, '');
    if (sym === cur) sym = '';
    each('[data-cx-code]', function (el) { el.textContent = cur; });
    each('[data-cx-sym]', function (el) { el.textContent = sym; });
    each('[data-cx-flag]', function (el) { el.src = flagSrc[cur]; });
    Array.prototype.forEach.call(options, function (o) {
      var on = o.getAttribute('data-cx-option') === cur;
      o.classList.toggle('is-on', on);
      o.setAttribute(o.hasAttribute('aria-pressed') ? 'aria-pressed' : 'aria-selected', on ? 'true' : 'false');
    });
  }

  function apply(code) {
    restore();
    cur = code;
    labels();
    if (cur !== 'EUR') {
      walk(document.body);
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    refreshNotes();
    document.documentElement.classList.remove('cx-pending');
  }

  // Only the latest call may apply: a slow rates fetch must not undo a later pick.
  var seq = 0;
  var picked = false;
  var saveAuto = true; // false once a valid saved choice exists; set at start

  // Tracking (Mikus 2026-09-30): which currency a shopper saw, and how it was set.
  // - PostHog: every event carries display_currency + currency_source. The
  //   PostHog loader (snippets/custom-analytics.liquid, item 030) stamps them
  //   from window.tridosCurrency in its before_send hook (after consent only).
  // - Shopify: the cart carries two attributes, so every order records them
  //   (admin → order → Additional details). Two routes, so a fast checkout or
  //   an app's own add to cart cannot skip them: /cart/update.js once per cart
  //   and value (after the theme's add to cart, and on page load), and hidden
  //   attributes[...] inputs in every form that posts to /cart (the sticky
  //   Checkout and the cart page), which Shopify saves on the way to checkout.
  var source = 'default'; // shopper | country | default
  var SOURCE_LABEL = { shopper: 'Shopper picked it', country: 'Visitor country', default: 'Default (EUR)' };
  var CART_MEMO = 'tridos_cx_cart';

  function sourceOf(s) {
    return s.s || (s.m ? 'shopper' : 'country');
  }

  function cartToken() {
    var m = /(?:^|;\s*)cart=([^;]+)/.exec(document.cookie);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function syncCart() {
    var token = cartToken();
    if (!token) return;
    var stamp = token + '|' + cur + '|' + source;
    if (load(CART_MEMO) === stamp) return;
    save(CART_MEMO, stamp);
    fetch('/cart/update.js', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: cartAttributes() })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
    }).catch(function () {
      save(CART_MEMO, ''); // try again on the next page
    });
  }

  function cartAttributes() {
    return { 'Display currency': cur, 'Currency set by': SOURCE_LABEL[source] };
  }

  function stampForms() {
    var attrs = cartAttributes();
    each('form[action$="/cart"]', function (form) {
      Object.keys(attrs).forEach(function (k) {
        var name = 'attributes[' + k + ']';
        var input = form.querySelector('input[type="hidden"][name="' + name + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = attrs[k];
      });
    });
  }

  function publish() {
    window.tridosCurrency = { code: cur, source: source };
    stampForms();
    syncCart();
  }

  document.addEventListener('ajaxProduct:added', function () { setTimeout(syncCart, 0); });

  function choose(code, byVisitor, how) {
    var mine = ++seq;
    if (byVisitor) picked = true;
    var src = byVisitor ? 'shopper' : (how || 'country');
    var done = function () {
      if (byVisitor || saveAuto) save(KEY, { c: code, s: src });
      source = src;
      publish();
      // after publish(), so PostHog's before_send stamps the NEW currency on it
      if (byVisitor && window.posthog && window.posthog.capture) {
        window.posthog.capture('currency_changed', { currency: code });
      }
    };
    if (code === 'EUR') {
      if (cur !== 'EUR') apply('EUR');
      done();
      return Promise.resolve();
    }
    return loadRates().then(function (r) {
      if (mine !== seq) return;
      rates = r;
      if (code !== cur) apply(code);
      done();
    }).catch(function () {
      document.documentElement.classList.remove('cx-pending');
      if (mine !== seq) return;
      // Rates unavailable: the page stays in EUR, so the pill must say EUR too (the
      // snippet painted the saved code on it before first paint). The saved choice is
      // kept; the next page load tries again.
      if (cur === 'EUR') {
        source = 'default';
        labels();
      }
      publish();
    });
  }

  // Phone list: this product's price in every currency, filled when the list opens.
  function fillAmounts() {
    var price = document.querySelector(PRODUCT_PRICES + ' [data-product-price]');
    var eur = price && euroText(price);
    if (!eur) return;
    var eurRow = document.querySelector('.cx-menu [data-cx-option="EUR"] [data-cx-amt]');
    if (eurRow) eurRow.textContent = eur; // the shop's own euro price, exact
    loadRates().then(function (r) {
      rates = r;
      each('[data-cx-amt]', function (el) {
        var code = el.closest('[data-cx-option]').getAttribute('data-cx-option');
        if (code !== 'EUR') el.textContent = money(eurOf(eur.replace(/[^\d.,]/g, '')), code);
      });
    }).catch(function () {});
  }

  // The list flags are lazy; start loading them as soon as a hand is near the picker.
  function warm(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
  }

  // Desktop button + dropdown
  var sw = document.querySelector('[data-cx-switch]');
  if (sw) {
    var btn = sw.querySelector('[data-cx-toggle]');
    var drop = sw.querySelector('.cx-drop');
    ['pointerenter', 'focus'].forEach(function (ev) { btn.addEventListener(ev, function () { warm(drop); }, { once: true }); });
    var close = function () { drop.hidden = true; btn.setAttribute('aria-expanded', 'false'); };
    btn.addEventListener('click', function () {
      var open = drop.hidden;
      drop.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) (drop.querySelector('.is-on') || drop.querySelector('[data-cx-option]')).focus();
    });
    drop.addEventListener('click', function (e) {
      var o = e.target.closest('[data-cx-option]');
      if (!o) return;
      choose(o.getAttribute('data-cx-option'), true);
      close();
      btn.focus();
    });
    drop.addEventListener('keydown', function (e) {
      var opts = Array.prototype.slice.call(drop.querySelectorAll('[data-cx-option]'));
      var i = opts.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        opts[(i + (e.key === 'ArrowDown' ? 1 : opts.length - 1)) % opts.length].focus();
      } else if ((e.key === 'Enter' || e.key === ' ') && i > -1) {
        e.preventDefault();
        opts[i].click();
      }
    });
    document.addEventListener('click', function (e) { if (!drop.hidden && !sw.contains(e.target)) close(); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape' && !drop.hidden) { close(); btn.focus(); } });
  }

  // Phone MENU row + list. The theme's own slide-nav opens and closes the list.
  var row = document.querySelector('[data-cx-menu-row]');
  if (row) {
    row.addEventListener('click', fillAmounts);
    each('.js-toggle-slide-nav', function (t) {
      t.addEventListener('click', function () { warm(row.parentNode); }, { once: true });
    });
    row.parentNode.querySelector('.slide-nav__dropdown').addEventListener('click', function (e) {
      var o = e.target.closest('[data-cx-option]');
      if (!o) return;
      choose(o.getAttribute('data-cx-option'), true).then(function () {
        var back = row.parentNode.querySelector('[data-cx-back]');
        if (back) back.click();
      });
    });
  }

  // Start: the visitor's own choice, else their country, else EUR.
  var saved = load(KEY);
  // Provisional, until the lookup and the rates are in: PostHog may start first,
  // and its landing $pageview should still say which currency this visitor has.
  window.tridosCurrency = saved && codes.indexOf(saved.c) > -1
    ? { code: saved.c, source: sourceOf(saved) }
    : { code: 'EUR', source: 'default' };
  if (saved && codes.indexOf(saved.c) > -1) {
    saveAuto = false;
    choose(saved.c, false, sourceOf(saved));
  } else {
    labels();
    document.documentElement.classList.remove('cx-pending');
    fetch('/browsing_context_suggestions.json?country[enabled]=true')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (picked) return;
        var cc = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        var code = COUNTRY[cc] || 'EUR';
        return choose(codes.indexOf(code) > -1 ? code : 'EUR', false, 'country');
      })
      .catch(function () {
        if (seq > 0) return; // something (a pick, another tab) already chose
        source = 'default';
        publish();
      });
  }

  // A page restored with Back, or another open tab, follows a choice made elsewhere.
  function sync() {
    var s = load(KEY);
    if (s && codes.indexOf(s.c) > -1 && (s.c !== cur || sourceOf(s) !== source)) choose(s.c, false, sourceOf(s));
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
});

/* 051 — Feature usage tracking (docs/CUSTOMIZATIONS.md item 051).
   Tells PostHog which of our custom features shoppers SEE and which they USE, so the
   PostHog dashboard "Custom features — usage" and the monthly Slack report can say
   what earns its place and what could go.
     feature_viewed  { feature }                  once per page per feature, the first
                                                  time enough of it is on screen
     feature_used    { feature, action, value }   a tap on one of its controls
   Feature keys are fixed; the dashboard and the report group by them. A feature added
   here is counted from the next page view, and the "all features" tiles pick it up.

   Nothing runs until PostHog has started, which it does only after cookie consent
   (register 030). So the numbers cover consenting visitors, not every visitor: compare
   features with each other, not with Shopify's session count. A hidden feature (a
   `hidden` stub, a closed dropdown, the sold-out-only "Notify me" link) has no box on
   screen and counts only once it appears. Clicks are read in the capture phase,
   because block 045 replaces the YouTube button during its own click handler.

   The volume offer bar (033) and the currency picker (047) also keep their own,
   richer events (volume_offer_*, currency_changed). */
tridosBlock('051', function () {
  'use strict';

  // uses: [selector, action, value] — value is an attribute name, 'href', 'text', or a
  // fixed label. The first matching selector wins, so the list order matters.
  // An 'open_*' action on a toggle counts only the opening tap (see isNoop).
  var FEATURES = [
    // The tick's label forwards its click to the input, so the input is matched (once per
    // toggle; a disabled input gets no click). Its value is the state before the tap
    // ("on" = this tap unticks). A change of the variant select is not a click and is
    // not counted.
    { key: 'bought_together', root: '[data-tridos-bt]', uses: [
      ['[data-bt-row]:not([data-bt-self]) [data-bt-tick]', 'toggle', 'data-bt-state'],
      ['[data-bt-add]', 'add_all', 'text'],
      ['[data-tridos-bt] a', 'open_partner', 'href']
    ] },
    { key: 'volume_offer', root: '#tridos-vo' },
    { key: 'qty_stepper', root: '[data-tridos-qty]', uses: [
      ['[data-tridos-qty-minus]', 'minus'],
      ['[data-tridos-qty-plus]', 'plus']
    ] },
    { key: 'stock_row', root: '[data-tridos-stock]' },
    { key: 'notify_me', root: '.tridos-stock__notify', uses: [
      ['.tridos-stock__notify-link', 'open_form']
    ] },
    { key: 'delivery_estimate', root: '#tridos-dp', uses: [
      ['.tdp-cc-trigger', 'open_country_picker'],
      ['li[data-cc]:not([aria-disabled="true"])', 'pick_country', 'data-cc']
    ] },
    { key: 'review_stars_vendor', root: '.product-single__vendor .jdgm-widget', uses: [
      ['.product-single__vendor .jdgm-widget', 'click_stars']
    ] },
    // The tile stars sit inside the tile's link: a tap on them just opens the product,
    // so only "seen" is counted. The quick-shop pop-up is outside the link.
    { key: 'review_stars_tiles', root: '.grid-product__link .jdgm-preview-badge' },
    { key: 'bundle_contents', root: '[data-tridos-bc]', uses: [
      ['[data-tridos-bc] a', 'open_part', 'href']
    ] },
    { key: 'bundle_and_save', root: '[data-tridos-bc-in]', uses: [
      ['[data-tridos-bc-in] a', 'open_bundle', 'href']
    ] },
    { key: 'product_labels', root: '.tridos-labels' },
    { key: 'successor_card', root: '[data-tridos-succ]', uses: [
      ['[data-tridos-succ] a', 'open_successor', 'href']
    ] },
    { key: 'model_compare', root: '[data-tridos-cmp]', uses: [
      ['.tridos-cmp__old .tridos-cmp__btn', 'open_old_model', 'href'],
      ['.tridos-cmp__new .tridos-cmp__btn', 'open_new_model', 'href']
    ] },
    { key: 'youtube_embeds', root: '.tridos-yt', uses: [
      ['.tridos-yt__play', 'play', 'data-yt-id']
    ] },
    { key: 'instructions_page', root: '[data-tridos-instr]', uses: [
      ['[data-tridos-instr-chip]', 'pick_platform', 'data-tridos-instr-chip'],
      ['.tridos-instr__trigger', 'open_row', 'text'],
      ['.tridos-instr__product a', 'open_product', 'href']
    ] },
    { key: 'currency_picker', root: '[data-cx-switch], [data-cx-menu-row]', uses: [
      ['[data-cx-toggle]', 'open_picker', 'header'],
      ['[data-cx-menu-row]', 'open_picker', 'menu'],
      ['[data-cx-option]', 'pick', 'data-cx-option']
    ] },
    { key: 'stattrak_videos', root: '.st-stats' },
    { key: 'linked_options', root: '.lv-option-box', uses: [
      ['.lv-option-button, .lv-option-dropdown-option', 'pick_option', 'text']
    ] },
    // 052: the warning above the buy button, and the pop-up Add to cart opens (it is
    // cloned into <body>, so it has its own key; "seen" = the pop-up was shown). The tick
    // boxes are matched, not their rows: a tap on the "I already have these parts" row's text
    // (still a <label>) clicks its box a second time. Part rows tick on the box only.
    // 058 Add-ons is a 052 box with data-rp-optional; listed first, as the first match wins.
    { key: 'add_ons', root: '[data-tridos-rp][data-rp-optional]', uses: [
      ['[data-rp-optional] [data-rp-tick]', 'tick_addon'],
      ['[data-rp-optional] .tridos-rp__open', 'open_part', 'href'],
      ['[data-rp-optional] [data-rp-choose]', 'open_versions'],
      ['[data-rp-optional] [data-rp-more]', 'open_more', 'button'],
      ['[data-rp-optional]:not(.is-open) .tridos-rp__more--peek', 'open_more', 'faded_row']
    ] },
    { key: 'required_part', root: '[data-tridos-rp]:not([data-rp-optional])', uses: [
      ['[data-tridos-rp] [data-rp-tick]', 'tick_part'],
      ['[data-tridos-rp] .tridos-rp__open', 'open_part', 'href'],
      ['[data-tridos-rp] [data-rp-choose]', 'open_versions']
    ] },
    { key: 'required_part_popup', root: '.tridos-rp-modal__panel', uses: [
      ['.tridos-rp-modal [data-rp-decline]', 'pick_decline'],
      ['.tridos-rp-modal [data-rp-tick]', 'pick_part'],
      ['.tridos-rp-modal .tridos-rp__open', 'open_part', 'href'],
      ['.tridos-rp-modal [data-rp-choose]', 'open_versions'],
      ['.tridos-rp-modal [data-rp-go]', 'add', 'text'],
      ['.tridos-rp-modal [data-rp-close]', 'close']
    ] },
    // 052 version picker (V4): "seen" = it opened; the card text is the version picked.
    { key: 'required_part_versions', root: '.tridos-rp-picker__panel', uses: [
      ['.tridos-rp-picker [data-rp-version]', 'pick_version', 'data-rp-version-title'],
      ['.tridos-rp-picker [data-rp-picker-go]', 'use_version', 'text'],
      ['.tridos-rp-picker [data-rp-picker-close]', 'close']
    ] },
    // 053: the filter bar on collection and search pages. A pick is the checkbox itself:
    // a tap on its label clicks the box a second time, so the labels are not matched.
    { key: 'filter_bar', root: '.collection-filters', uses: [
      ['.collection-filters [data-tridos-fb-group]', 'open_filter', 'data-tridos-fb-group'],
      ['.collection-filters .tag__input', 'pick', 'data-tridos-fb-value'],
      ['.collection-filters [data-tridos-fb-clear]', 'clear'],
      ['.collection-filters [data-tridos-fb-show]', 'show_results']
    ] },
    // 059: the sliders are counted by onChange below (a drag on a phone sends no click).
    { key: 'bb_check', root: '[data-tridos-bbc]', uses: [
      ['[data-tridos-bbc] .tridos-bbc__how summary', 'open_how']
    ] },
    // 055: the TE211M / TE210MS video comparison (TE210MS page only).
    // data-tvc-action = what the tap does: pause / play, turn_off / turn_on (the flip).
    { key: 'video_compare', root: '[data-tvc]', uses: [
      ['[data-tvc-show]', 'switch', 'data-tvc-show'],
      ['[data-tvc-auto]', 'auto_switch', 'data-tvc-action'],
      ['[data-tvc-pause]', 'pause_play', 'data-tvc-action'],
      ['[data-tvc-note] a', 'open_note_link', 'href']
    ] },
    // 056: sales page sections (TE210MS page first).
    { key: 'spec_strip', root: '.tridos-specs' },
    { key: 'mount_promo', root: '[data-tridos-mount]', uses: [
      ['[data-tridos-mount-bundle]', 'open_bundle', 'href'],
      ['[data-tridos-mount-part]', 'open_part', 'href']
    ] },
    { key: 'callout_card', root: '.tridos-callout' },
    { key: 'in_the_box', root: '.tridos-box' }
  ];

  var started = false;
  var viewed = {};
  var observer = null;
  var mutations = null;

  function send(event, props) {
    try {
      if (window.posthog && window.posthog.__loaded) window.posthog.capture(event, props);
    } catch (err) {}
  }

  // "Seen" = half of it on screen, or 150 px of it when it is taller than 300 px (the
  // comparison table and the instructions list never fit half on a phone screen).
  // The observer reports every 1 % step (see start), so even a very tall block gets a
  // report soon after its first 150 px are in view.
  function seen(entry) {
    if (!entry.isIntersecting) return false;
    var h = entry.boundingClientRect.height;
    return h > 0 && entry.intersectionRect.height >= Math.min(150, h / 2);
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      var key = entry.target._tridosFeature;
      if (!key || viewed[key] || !seen(entry)) return;
      viewed[key] = true;
      send('feature_viewed', props(key, entry.target));
      Array.prototype.forEach.call(document.querySelectorAll('[data-tridos-watched="' + key + '"]'), function (el) {
        observer.unobserve(el);
      });
    });
    if (mutations && FEATURES.every(function (f) { return viewed[f.key]; })) mutations.disconnect();
  }

  // A product form inside the quick-shop pop-up (collection pages) is flagged, so its
  // numbers can be told apart from the product page's.
  function props(key, el) {
    var p = { feature: key };
    // 057's "you bought this" note only works for logged-in shoppers; this says how many are.
    p.logged_in = window.tridosLoggedIn === true;
    if (el.closest && el.closest('[data-modal="true"]')) p.quick_shop = true;
    return p;
  }

  function scan() {
    FEATURES.forEach(function (f) {
      if (viewed[f.key]) return;
      Array.prototype.forEach.call(document.querySelectorAll(f.root), function (el) {
        if (el._tridosFeature) return;
        el._tridosFeature = f.key;
        el.setAttribute('data-tridos-watched', f.key);
        observer.observe(el);
      });
    });
  }

  function valueOf(el, how) {
    if (!how) return null;
    if (how === 'text') return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80) || null;
    if (how === 'href') {
      var href = el.getAttribute('href');
      return href ? href.split(/[?#]/)[0] : null;
    }
    if (how.indexOf('data-') === 0) return el.getAttribute(how);
    return how;
  }

  // Runs before the control's own handler (capture phase), so the state read here is
  // the state before the tap. A tap that closes, or changes nothing, is not a use.
  function isNoop(el, action) {
    if (el.disabled || el.getAttribute('aria-disabled') === 'true') return true;
    if (action.indexOf('open_') === 0 &&
        (el.getAttribute('aria-expanded') === 'true' || el.classList.contains('is-open') ||
         (el.tagName === 'SUMMARY' && el.parentNode && el.parentNode.open))) return true;
    if (action === 'minus') {
      var input = el.parentNode && el.parentNode.querySelector('input');
      var min = parseInt(input && input.getAttribute('min'), 10) || 1;
      if (input && (parseInt(input.value, 10) || 0) <= min) return true;
    }
    return false;
  }

  function onClick(evt) {
    var target = evt.target;
    if (!target || !target.closest) return;
    flushSearch(); // a tap on a result can leave the page before the search timer fires
    for (var i = 0; i < FEATURES.length; i++) {
      var uses = FEATURES[i].uses || [];
      for (var j = 0; j < uses.length; j++) {
        var el = target.closest(uses[j][0]);
        if (!el) continue;
        if (isNoop(el, uses[j][1])) return;
        var p = props(FEATURES[i].key, el);
        p.action = uses[j][1];
        p.value = valueOf(el, uses[j][2]);
        send('feature_used', p);
        return;
      }
    }
  }

  // 046 search box: one event per search, sent when typing pauses for 1.5 s, on the
  // next tap, or when the page is left, whichever comes first. The same words twice in
  // a row count once.
  var searchTimer = null;
  var searchInput = null;
  var lastSearch = '';
  function flushSearch() {
    if (!searchInput) return;
    clearTimeout(searchTimer);
    var q = (searchInput.value || '').replace(/\s+/g, ' ').trim().toLowerCase().slice(0, 60);
    searchInput = null;
    if (!q || q === lastSearch) return;
    lastSearch = q;
    send('feature_used', { feature: 'instructions_page', action: 'search', value: q });
  }
  function onInput(evt) {
    var input = evt.target;
    if (!input || !input.matches || !input.matches('[data-tridos-instr-search]')) return;
    searchInput = input;
    clearTimeout(searchTimer);
    searchTimer = setTimeout(flushSearch, 1500);
  }

  // 059 sliders: one event per finished change (end of a drag, a tap on the track, an
  // arrow key); the value says which slider (w = BB weight, j = power).
  function onChange(evt) {
    var input = evt.target;
    if (!input || !input.matches || !input.matches('[data-tridos-bbc] [data-in]')) return;
    send('feature_used', { feature: 'bb_check', action: 'set_slider', value: input.getAttribute('data-in') });
  }

  function start() {
    if (started || !window.IntersectionObserver) return;
    started = true;
    var thresholds = [];
    for (var t = 0; t <= 100; t++) thresholds.push(t / 100);
    observer = new IntersectionObserver(onIntersect, { threshold: thresholds });
    scan();
    document.addEventListener('click', onClick, true);
    document.addEventListener('input', onInput, true);
    document.addEventListener('change', onChange, true);
    window.addEventListener('pagehide', flushSearch);
    // Widgets and apps draw their parts later (offer bar, delivery estimate, Judge.me,
    // linked options, quick shop). A rescan at most every 400 ms catches them; it stops
    // once every feature has been seen.
    if (window.MutationObserver) {
      var timer = null;
      mutations = new MutationObserver(function () {
        if (timer) return;
        timer = setTimeout(function () { timer = null; scan(); }, 400);
      });
      mutations.observe(document.body, { childList: true, subtree: true });
    }
  }

  // PostHog starts late (after consent, then idle). snippets/custom-analytics.liquid
  // fires tridos:posthog-ready once it has; it may have happened before this ran.
  if (window.posthog && window.posthog.__loaded) start();
  else document.addEventListener('tridos:posthog-ready', start);
});

/* 052 — "Required part(s) · not included" (snippets/tridos-required-part.liquid and
   tridos-required-part-row.liquid, custom.css block 052). A product whose
   tridos.required_part_text metafield is set shows the warning above its buy button, with a
   tick row for each part we sell (tridos.required_parts, a list).

   - A part with versions (the Core Mount: SSX23 metal / MK23 plastic) has "Choose version":
     a small picker (Mikus's V4, 2026-10-05) with each version's own photo, name and price.
     Ticking such a part opens the picker; closing it without a pick unticks the part.
   - Ticked parts → Add to cart adds the product, then those parts (same quantity), and the
     button says "Add 3 items to cart · €70.00".
   - Otherwise Add to cart opens the pop-up for the parts that are neither ticked nor in the
     cart: tick any parts (several allowed), or tick "I already have these parts" (which
     unticks them all) and add only this item. The button waits until every ticked part
     with versions has one. With no part set up at all (warning only, or the TDC 2.0
     chamber check) the box is a confirmation and the button says "Add to cart · €X".
   The theme's own add-to-cart (theme.js AjaxProduct) adds the product, so the sticky cart
   bar, analytics and error messages work as before. We stop its submit in the capture
   phase and send it on again with requestSubmit(). The parts are added only after the
   theme reports the product added (ajaxProduct:added with a product), so a failed product
   add never leaves lone parts in the cart; a failed part add shows the theme's error box.
   Fail open: if anything here breaks, the product goes into the cart as if we were absent.

   058 "Add-ons" (snippets/tridos-add-ons.liquid) is the same widget with data-rp-optional,
   under the required box: same rows, same picker, its ticked items join this one's on the
   button and in the cart. It never opens the pop-up; on its own it only steps in when
   something is ticked. "Show N more" opens the rows past the first two. */
tridosBlock('052', function () {
  'use strict';

  var WIDGET = '[data-tridos-rp]';
  var REQUIRED = '[data-tridos-rp]:not([data-rp-optional])';
  var OPTIONAL = '[data-tridos-rp][data-rp-optional]';
  var PASS = '_tridosRpPass';
  var BUSY = '_tridosRpBusy';

  // Not form.id: the product form has a field named "id" (the variant), and the browser
  // hands that field back for form.id instead of the form's own id.
  function idOf(form) {
    return form.getAttribute('id') || '';
  }

  // The form's required-part box (selector REQUIRED) or its Add-ons box (OPTIONAL).
  function widgetFor(form, which) {
    if (!form || !idOf(form)) return null;
    var block = form.closest('.product-block');
    var holder = block && block.parentElement;
    if (!holder) return null;
    var w = holder.querySelector(':scope > ' + (which || REQUIRED));
    return w && w.getAttribute('data-form-id') === idOf(form) ? w : null;
  }

  function addOnsFor(form) {
    return widgetFor(form, OPTIONAL);
  }

  // The Add-ons ticked on the page and ready to add (a version picked where needed).
  function extras(form) {
    var a = addOnsFor(form);
    var d = a && data(a);
    var rows = a && a.querySelector('.tridos-rp__parts');
    return d && rows ? tickedVariants(rows, d, a._tridosRpSel || {}) : [];
  }

  function formOf(w) {
    var id = w.getAttribute('data-form-id');
    var found = null;
    Array.prototype.forEach.call(w.parentElement.querySelectorAll('form'), function (f) {
      if (idOf(f) === id) found = f;
    });
    return found;
  }

  function data(w) {
    if (w._tridosRp === undefined) {
      try {
        w._tridosRp = JSON.parse(w.querySelector('[data-rp-data]').textContent);
        w._tridosRp.parts = w._tridosRp.parts || [];
      } catch (e) {
        w._tridosRp = null;
      }
    }
    return w._tridosRp;
  }

  function qty(form) {
    var input = form.querySelector('[name="quantity"]') ||
      document.querySelector('[name="quantity"][form="' + idOf(form) + '"]');
    var n = parseInt(input && input.value, 10);
    return n > 0 ? n : 1;
  }

  function variantPrice(form, d) {
    var select = form.querySelector('[name="id"]');
    var price = select && d.prices[select.value];
    return typeof price === 'number' ? price : 0;
  }

  function money(cents) {
    return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Button labels as HTML: formatMoney returns markup (<span class=money>, which the
  // 047 currency picker converts), so the price goes in as HTML and the words escaped.
  function label(template, count, cents) {
    return escapeHtml(template)
      .replace('[count]', String(count))
      .replace('[price]', money(cents));
  }

  function partById(d, id) {
    for (var i = 0; i < d.parts.length; i++) if (String(d.parts[i].id) === String(id)) return d.parts[i];
    return null;
  }

  function variantOf(part, id) {
    for (var i = 0; i < part.variants.length; i++) if (String(part.variants[i].id) === String(id)) return part.variants[i];
    return null;
  }

  function buyable(part) {
    return part.variants.filter(function (v) { return v.available; });
  }

  // The variant a part would add: the chosen one, or the only one when it has no versions.
  function chosenVariant(part, sel) {
    if (sel[part.id]) return variantOf(part, sel[part.id]);
    if (!part.multi) return buyable(part)[0] || null;
    return null;
  }

  // "Add 3 items to cart · €70.00": this product plus the given part variants, times the quantity.
  function manyLabel(form, d, variants) {
    var q = qty(form);
    var sum = variantPrice(form, d);
    variants.forEach(function (v) { sum += v.price; });
    return label(d.strings.addMany, q * (1 + variants.length), sum * q);
  }

  function addBtn(form) {
    return form.querySelector('[data-add-to-cart]');
  }

  function setBusy(form, on) {
    form[BUSY] = on;
    var btn = addBtn(form);
    if (btn) btn.classList.toggle('btn--loading', on);
  }

  function showError(form, text) {
    var old = form.querySelector('.errors');
    if (old) old.remove();
    var div = document.createElement('div');
    div.classList.add('errors', 'text-center');
    div.textContent = text;
    form.append(div);
  }

  // Hand the submit back to the theme. On the next tick: a browser ignores requestSubmit()
  // on a form whose submit event is still being dispatched (our listener's own call).
  // The flag lets it past our listener once and is cleared right after, so a submit the
  // browser refuses (form validation) cannot leave it set for a later click.
  function pass(form) {
    setTimeout(function () {
      form[PASS] = true;
      try {
        if (typeof form.requestSubmit === 'function') {
          var btn = addBtn(form);
          form.requestSubmit(btn && btn.form === form ? btn : undefined);
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      } finally {
        form[PASS] = false;
      }
    }, 0);
  }

  function getCart() {
    if (theme.cart && typeof theme.cart.getCart === 'function') return theme.cart.getCart();
    return fetch(theme.routes.cart + '?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  // Product ids already in the cart (a part there needs no pop-up).
  function cartProductIds() {
    return getCart().then(function (cart) {
      var ids = {};
      (cart.items || []).forEach(function (item) { ids[item.product_id] = true; });
      return ids;
    });
  }

  // A box's page tick boxes, cleared (after an add, after "I already have these parts").
  function untick(w) {
    if (w) Array.prototype.forEach.call(w.querySelectorAll('.tridos-rp__parts [data-rp-tick]'), function (t) { t.checked = false; });
  }

  // POST variants to the cart (same quantity each). Resolves to null when done, or to the
  // error text (failText + Shopify's reason) when the request is refused or fails.
  // via tags each line with a hidden property, _tridos_via = 'required-part' | 'add-ons', so
  // an order shows which items these boxes sold (Mikus 2026-10-20). The leading "_" hides it
  // in the cart, checkout and emails. A line with a tag is a separate cart line from the
  // same variant added by hand.
  function postItems(variants, q, failText, via) {
    if (!variants.length) return Promise.resolve(null);
    return fetch(theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: variants.map(function (v) {
        return { id: v.id, quantity: q, properties: { _tridos_via: via } };
      }) })
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) return failText + ' ' + (res.body.description || res.body.message || '');
        // Same event the theme fires: the sticky cart bar redraws, analytics logs each item.
        (res.body.items || []).forEach(function (item) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } }));
        });
        return null;
      })
      .catch(function () { return failText; });
  }

  /* Product first (by the theme), then the required parts in one request, then the ticked
     add-ons (058) in a second one: an add-on that cannot be added (too few in stock) never
     costs the shopper a required part, and the error names what failed. theme.js fires
     ajaxProduct:added on the form (bubbling, with detail.product) on success, and on
     document with no detail on a 422. Either way the one-shot listener goes; a timeout
     cleans up if neither comes. */
  function addProductThenParts(form, d, variants, addOns) {
    var q = qty(form);
    var done = false;
    addOns = addOns || [];
    // Busy until the last request is back: a second tap in between must not add the
    // product, parts or add-ons twice. The button shows the theme's loading state meanwhile.
    form[BUSY] = true;
    function finish(event) {
      // Another form's or feature's success (a part we posted, a second product form, the 057
      // card, a quick-shop pop-up) is not ours: keep waiting. The theme's 422 comes on
      // document with no detail, and still ends the wait.
      if (event && event.target !== form && event.detail && event.detail.product) return;
      if (done) return;
      done = true;
      document.removeEventListener('ajaxProduct:added', finish);
      clearTimeout(timer);
      if (!event || event.target !== form || !event.detail || !event.detail.product) {
        form[BUSY] = false;
        return;
      }
      setBusy(form, true);
      var a = addOnsFor(form);
      var ad = (a && data(a)) || d;
      var errors = [];
      // What went in is unticked, so the next Add to cart does not add it a second time (the
      // chosen versions are remembered); what failed stays ticked.
      postItems(variants, q, d.strings.partFailed, 'required-part').then(function (err) {
        if (err) errors.push(err); else if (variants.length) untick(widgetFor(form));
        return postItems(addOns, q, ad.strings.partFailed, 'add-ons');
      }).then(function (err) {
        if (err) errors.push(err); else if (addOns.length) untick(a);
        setBusy(form, false);
        if (errors.length) showError(form, errors.join(' '));
        refreshForm(form);
      }).catch(function () { setBusy(form, false); });
    }
    var timer = setTimeout(finish, 20000);
    document.addEventListener('ajaxProduct:added', finish);
    pass(form);
  }

  // Open dialogs register a cancel function here, so a page restored by Back can close
  // them properly (listeners released, a version-less tick undone).
  var openDialogs = [];

  // The dialog on top: the picker when it is open over the pop-up.
  function topDialog() {
    var all = document.querySelectorAll('body > .tridos-rp-modal, body > .tridos-rp-picker');
    return all[all.length - 1] || null;
  }

  // Tab stays inside an open dialog; Escape closes it. Only the dialog on top listens, so
  // Escape over the picker closes the picker, not the pop-up under it. Returns the remover.
  function trap(panel, onEscape) {
    function onKey(event) {
      var top = topDialog();
      if (!top || !top.contains(panel)) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        onEscape();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = Array.prototype.slice.call(
        panel.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]')
      );
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      var outside = active === panel || !panel.contains(active);
      if (event.shiftKey && (active === first || outside)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (active === last || outside)) { event.preventDefault(); first.focus(); }
    }
    document.addEventListener('keydown', onKey, true);
    return function () { document.removeEventListener('keydown', onKey, true); };
  }

  /* The version picker (V4). Calls onPick(variantId) or onCancel(). It sits above the
     pop-up when opened from there (custom.css gives it the higher z-index). */
  function openPicker(w, part, currentId, onPick, onCancel) {
    var d = data(w);
    var tpl = w.querySelector('template[data-rp-picker]');
    var picker = tpl && tpl.content.firstElementChild && tpl.content.firstElementChild.cloneNode(true);
    if (!picker) return onCancel();
    var trigger = document.activeElement;
    var panel = picker.querySelector('.tridos-rp-picker__panel');
    var go = picker.querySelector('[data-rp-picker-go]');
    var picked = currentId ? String(currentId) : '';

    picker.querySelector('[data-rp-picker-sub]').textContent = part.option ? part.title + ' · ' + part.option : part.title;
    var list = picker.querySelector('[data-rp-picker-list]');
    part.variants.forEach(function (v) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'tridos-rp-picker__card';
      card.setAttribute('data-rp-version', v.id);
      card.setAttribute('data-rp-version-title', v.title);
      card.disabled = !v.available;
      card.innerHTML = (v.img ? '<img src="' + escapeHtml(v.img) + '" alt="" loading="lazy">' : '<span class="tridos-rp-picker__noimg"></span>') +
        '<span class="tridos-rp-picker__name">' + escapeHtml(v.title) +
        '</span><span class="tridos-rp-picker__price">' + (v.available ? money(v.price) : escapeHtml(d.strings.soldOut)) + '</span>';
      list.appendChild(card);
    });

    function mark() {
      Array.prototype.forEach.call(list.children, function (c) {
        var on = c.getAttribute('data-rp-version') === picked;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var v = picked && variantOf(part, picked);
      go.disabled = !v || !v.available;
      go.textContent = v ? d.strings.useVersion.replace('[version]', v.title) : d.strings.chooseFirst;
    }

    var release;
    function close(result) {
      release();
      var at = openDialogs.indexOf(cancel);
      if (at > -1) openDialogs.splice(at, 1);
      picker.remove();
      if (!document.querySelector('body > .tridos-rp-modal')) document.body.classList.remove('tridos-rp-open');
      if (trigger && trigger.focus) trigger.focus();
      if (result) onPick(result); else onCancel();
    }
    function cancel() { close(null); }

    list.addEventListener('click', function (event) {
      var card = event.target.closest('[data-rp-version]');
      if (!card || card.disabled) return;
      picked = card.getAttribute('data-rp-version');
      mark();
    });
    Array.prototype.forEach.call(picker.querySelectorAll('[data-rp-picker-close]'), function (el) {
      el.addEventListener('click', function () { close(null); });
    });
    go.addEventListener('click', function () { if (picked) close(picked); });

    document.body.appendChild(picker);
    document.body.classList.add('tridos-rp-open');
    release = trap(panel, cancel);
    openDialogs.push(cancel);
    mark();
    if (panel) panel.focus();
  }

  // A part row's price and "Frame Compatibility: Tokyo Marui" line for the given variant.
  function paintRow(row, part, variant, d) {
    var price = row.querySelector('[data-rp-price]');
    if (price && part.variants.some(function (v) { return v.available; })) {
      var cents = variant ? variant.price : Math.min.apply(null, buyable(part).map(function (v) { return v.price; }));
      price.innerHTML = '+' + money(cents);
    }
    var chosen = row.querySelector('[data-rp-chosen]');
    var choose = row.querySelector('[data-rp-choose]');
    if (chosen) {
      chosen.hidden = !variant;
      chosen.innerHTML = variant ? (part.option ? escapeHtml(part.option) + ': ' : '') + '<strong>' + escapeHtml(variant.title) + '</strong>' : '';
    }
    if (choose) choose.textContent = variant ? d.strings.change : d.strings.choose;
  }

  // Ticking a part that has versions but none chosen opens the picker; closing it without
  // a pick unticks the part again.
  function wireRows(container, w, d, sel, onChange) {
    function rowFor(el) {
      var row = el.closest('[data-rp-part]');
      return row && { row: row, part: partById(d, row.getAttribute('data-rp-part')) };
    }
    function choose(row, part, tick) {
      openPicker(w, part, sel[part.id], function (id) {
        sel[part.id] = id;
        if (tick) tick.checked = true;
        paintRow(row, part, variantOf(part, id), d);
        onChange(tick);
      }, function () {
        if (tick && !sel[part.id]) tick.checked = false;
        onChange();
      });
    }
    container.addEventListener('change', function (event) {
      var tick = event.target;
      if (!tick.matches || !tick.matches('[data-rp-tick]')) return;
      var r = rowFor(tick);
      if (!r || !r.part) return;
      if (tick.checked && r.part.multi && !sel[r.part.id]) choose(r.row, r.part, tick);
      onChange(tick);
    });
    container.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-rp-choose]');
      if (!btn || !container.contains(btn)) return;
      var r = rowFor(btn);
      if (r && r.part) choose(r.row, r.part, r.row.querySelector('[data-rp-tick]'));
    });
    Array.prototype.forEach.call(container.querySelectorAll('[data-rp-part]'), function (row) {
      var part = partById(d, row.getAttribute('data-rp-part'));
      if (part) paintRow(row, part, part.multi && sel[part.id] ? variantOf(part, sel[part.id]) : null, d);
    });
  }

  // The parts ticked on the page (or in the pop-up) that are ready to add.
  function tickedVariants(container, d, sel) {
    var out = [];
    Array.prototype.forEach.call(container.querySelectorAll('[data-rp-part]'), function (row) {
      var tick = row.querySelector('[data-rp-tick]');
      var part = partById(d, row.getAttribute('data-rp-part'));
      if (!tick || !tick.checked || !part || row.hidden) return;
      var v = chosenVariant(part, sel);
      if (v && v.available) out.push(v);
    });
    return out;
  }

  // "[version]" in the pop-up's words → the version of this product picked in the form.
  function fillVersion(modal, form, d) {
    var select = form.querySelector('[name="id"]');
    var title = (select && d.versions && d.versions[select.value]) || '';
    var walker = document.createTreeWalker(modal, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('[version]') > -1) node.nodeValue = node.nodeValue.split('[version]').join(title);
    }
  }

  function openPopup(form, w, d, sel, show) {
    var tpl = w.querySelector('template[data-rp-popup]');
    var modal = tpl && tpl.content.firstElementChild && tpl.content.firstElementChild.cloneNode(true);
    if (!modal) return pass(form);
    fillVersion(modal, form, d);

    var trigger = document.activeElement;
    var panel = modal.querySelector('.tridos-rp-modal__panel');
    var go = modal.querySelector('[data-rp-go]');
    var decline = modal.querySelector('[data-rp-decline]');
    var psel = {};
    Object.keys(sel).forEach(function (k) { psel[k] = sel[k]; });

    // Only the parts still missing, plus the ones ticked on the page (carried over).
    var pageTicks = {};
    Array.prototype.forEach.call(w.querySelectorAll('.tridos-rp__parts [data-rp-part]'), function (row) {
      var t = row.querySelector('[data-rp-tick]');
      if (t && t.checked) pageTicks[row.getAttribute('data-rp-part')] = true;
    });
    Array.prototype.forEach.call(modal.querySelectorAll('[data-rp-part]'), function (row) {
      var id = row.getAttribute('data-rp-part');
      row.hidden = !show[id];
      var t = row.querySelector('[data-rp-tick]');
      if (t && pageTicks[id]) t.checked = true;
    });

    function rows() {
      return Array.prototype.filter.call(modal.querySelectorAll('[data-rp-part]'), function (r) { return !r.hidden; });
    }
    function update() {
      var waiting = rows().some(function (row) {
        var t = row.querySelector('[data-rp-tick]');
        var part = partById(d, row.getAttribute('data-rp-part'));
        return t && t.checked && part && part.multi && !psel[part.id];
      });
      var ready = tickedVariants(modal, d, psel);
      var extra = extras(form); // 058: Add-ons ticked on the page go in too
      if (waiting) {
        go.disabled = true;
        go.textContent = d.strings.chooseFirst;
      } else if (ready.length) {
        go.disabled = false;
        go.innerHTML = manyLabel(form, d, ready.concat(extra));
      } else if (decline.checked && extra.length) {
        go.disabled = false;
        go.innerHTML = manyLabel(form, d, extra);
      } else if (decline.checked) {
        go.disabled = false;
        // "Add only this item · €X", or "Add to cart · €X" when no part is set up at all
        // (the snippet picks the words: a warning-only product or the TDC 2.0 check).
        go.innerHTML = label(d.strings.addOnly, 0, variantPrice(form, d) * qty(form));
      } else {
        go.disabled = true;
        go.textContent = d.strings.addToCart;
      }
    }

    var release;
    function close() {
      release();
      var at = openDialogs.indexOf(close);
      if (at > -1) openDialogs.splice(at, 1);
      modal.remove();
      if (!document.querySelector('body > .tridos-rp-picker')) document.body.classList.remove('tridos-rp-open');
      form[BUSY] = false;
      if (trigger && trigger.focus) trigger.focus();
    }

    wireRows(modal, w, d, psel, function (tick) {
      if (tick && tick.checked) decline.checked = false;
      update();
    });
    decline.addEventListener('change', function () {
      if (decline.checked) {
        rows().forEach(function (row) {
          var t = row.querySelector('[data-rp-tick]');
          if (t) t.checked = false;
        });
      }
      update();
    });
    Array.prototype.forEach.call(modal.querySelectorAll('[data-rp-close]'), function (el) {
      el.addEventListener('click', close);
    });
    go.addEventListener('click', function () {
      if (go.disabled) return;
      var ready = tickedVariants(modal, d, psel);
      var extra = extras(form);
      close();
      if (!ready.length) {
        // "I already have these parts": no part stays ticked on the page either.
        untick(w);
        refreshForm(form);
      }
      if (ready.length || extra.length) addProductThenParts(form, d, ready, extra);
      else pass(form);
    });

    document.body.appendChild(modal);
    document.body.classList.add('tridos-rp-open');
    release = trap(panel, close);
    openDialogs.push(close);
    update();
    // Focus the panel, not the first box: a mouse user gets no focus ring, and Tab
    // goes straight to the choices.
    if (panel) panel.focus();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM' || form[PASS]) return;
    var w = widgetFor(form);
    var d = w && data(w);
    if (!d) {
      // 058: only an Add-ons box. Nothing ticked → the theme adds the product as usual.
      var ad = null;
      var picked = [];
      try {
        var a = addOnsFor(form);
        ad = a && data(a);
        picked = ad ? extras(form) : [];
      } catch (e) {
        picked = []; // fail open
      }
      if (!picked.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form[BUSY]) return;
      try {
        addProductThenParts(form, ad, [], picked);
      } catch (e) {
        form[BUSY] = false;
        pass(form);
      }
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    // A second click while we check the cart or the pop-up is open does nothing.
    if (form[BUSY]) return;
    try {
      var sel = w._tridosRpSel || {};
      var pageRows = w.querySelector('.tridos-rp__parts');
      var ready = pageRows ? tickedVariants(pageRows, d, sel) : [];
      var extra = extras(form);
      var readyIds = {};
      ready.forEach(function (v) {
        d.parts.forEach(function (p) { if (variantOf(p, v.id)) readyIds[p.id] = true; });
      });
      // A sold-out part cannot be added, so it never holds the order up; it still shows in
      // the warning. With no part to buy at all, the pop-up is the warning (decline only).
      var forSale = d.parts.filter(function (p) { return buyable(p).length; });
      var missing = forSale.filter(function (p) { return !readyIds[p.id]; });
      // Alternatives (d.one): one ticked part is the whole requirement. The shopper may
      // still tick more (two holsters, one plate and one belt loop).
      if (forSale.length && (!missing.length || (d.one && ready.length))) {
        addProductThenParts(form, d, ready, extra);
        return;
      }
      if (!forSale.length) {
        form[BUSY] = true; // until the pop-up closes
        openPopup(form, w, d, sel, {});
        return;
      }
      setBusy(form, true);
      cartProductIds().catch(function () { return {}; }).then(function (inCart) {
        setBusy(form, false);
        var show = {};
        var left = 0;
        forSale.forEach(function (p) {
          if (readyIds[p.id]) show[p.id] = true;
          else if (!inCart[p.id]) { show[p.id] = true; left++; }
        });
        // Alternatives: one of them already in the cart is enough (sold out today or not).
        if (d.one && d.parts.some(function (p) { return inCart[p.id]; })) left = 0;
        if (!left) {
          if (ready.length || extra.length) addProductThenParts(form, d, ready, extra);
          else pass(form);
          return;
        }
        form[BUSY] = true; // until the pop-up closes
        openPopup(form, w, d, sel, show);
      }).catch(function () {
        setBusy(form, false);
        pass(form);
      });
    } catch (e) {
      setBusy(form, false);
      pass(form);
    }
  }, true);

  /* The button text while parts are ticked. Our label sits in a [data-rp-label] wrapper.
     theme.js rewrites the button text on a variant change ("Add to cart" / "Sold Out"),
     which drops the wrapper: then what it wrote is the text to put back when the boxes
     are unticked or the variant sells out. */
  function refresh(w) {
    refreshForm(formOf(w));
  }

  // Every form with a box inside scope, once each (a form can have both boxes).
  function refreshForms(scope) {
    var seen = [];
    Array.prototype.forEach.call(scope.querySelectorAll(WIDGET), function (w) {
      var form = formOf(w);
      if (form && seen.indexOf(form) < 0) { seen.push(form); refreshForm(form); }
    });
  }

  // One text for the form's button: the ticked required parts plus the ticked add-ons.
  function refreshForm(form) {
    if (!form) return;
    var w = widgetFor(form);
    var a = addOnsFor(form);
    var d = (w && data(w)) || (a && data(a));
    var rows = w && w.querySelector('.tridos-rp__parts');
    var span = form.querySelector('[data-add-to-cart-text]');
    var btn = addBtn(form);
    if (!d || !span || !btn) return;
    var ready = (rows ? tickedVariants(rows, d, w._tridosRpSel || {}) : []).concat(extras(form));
    var ours = !!span.querySelector('[data-rp-label]');
    if (ready.length && !btn.disabled) {
      if (!ours) span._tridosRpSaved = span.innerHTML;
      span.innerHTML = '<span data-rp-label>' + manyLabel(form, d, ready) + '</span>';
    } else if (ours) {
      span.innerHTML = span._tridosRpSaved || escapeHtml(d.strings.addToCart);
    }
  }

  function setup(w) {
    if (w._tridosRpWired) return;
    var d = data(w);
    var rows = w.querySelector('.tridos-rp__parts');
    if (!d || !rows) return;
    w._tridosRpWired = true;
    w._tridosRpSel = {};
    wireRows(rows, w, d, w._tridosRpSel, function () { refresh(w); });
    // 058: "Show N more" opens the rows past the first two, for good: there is no "Show
    // less", so a ticked add-on can never end up hidden yet still in the order. A tap on
    // the faded third row opens them too; while faded, that row's box and version button
    // cannot be reached (no focus, hidden from screen readers — the button says it all).
    var more = w.querySelector('[data-rp-more]');
    if (more) {
      var peek = w.querySelector('.tridos-rp__more--peek');
      var fade = function (on) {
        if (!peek) return;
        if (on) peek.setAttribute('aria-hidden', 'true'); else peek.removeAttribute('aria-hidden');
        Array.prototype.forEach.call(peek.querySelectorAll('input, button, a'), function (el) {
          if (on) el.setAttribute('tabindex', '-1'); else el.removeAttribute('tabindex');
        });
      };
      var open = function () {
        var hadFocus = document.activeElement === more;
        w.classList.add('is-open');
        fade(false);
        more.hidden = true;
        // The button is gone, so its focus goes on to the first new row (no scroll).
        var next = w.querySelector('.tridos-rp__more [data-rp-tick]');
        if (next && hadFocus) next.focus({ preventScroll: true });
      };
      fade(true);
      more.addEventListener('click', open);
      if (peek) {
        peek.addEventListener('click', function (event) {
          if (w.classList.contains('is-open')) return;
          event.preventDefault(); // the tap opens the list; it does not tick the row
          open();
        }, true);
      }
    }
  }

  tridosOnVariantChange('052', function (section) {
    // theme.js writes the button text in its own listener, which runs first.
    setTimeout(function () { refreshForms(section); }, 0);
  });

  document.addEventListener('input', function (event) {
    var el = event.target;
    if (el.name === 'quantity' && el.form) refreshForm(el.form);
  });
  document.addEventListener('change', function (event) {
    var el = event.target;
    if (el.name === 'quantity' && el.form) refreshForm(el.form);
  });

  // A tick the browser restored (reload, Back) must not count: a restored box has no
  // version behind it, so start clean.
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(WIDGET), function (w) {
      untick(w);
      setup(w);
    });
    refreshForms(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Back from a link tapped inside the pop-up: the browser restores the page as it was,
  // pop-up open and the form busy. Close it and free the form.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    // Top first: the picker's cancel undoes a version-less tick, then the pop-up closes.
    openDialogs.slice().reverse().forEach(function (cancel) { cancel(); });
    Array.prototype.forEach.call(document.querySelectorAll('body > .tridos-rp-modal, body > .tridos-rp-picker'), function (m) { m.remove(); });
    document.body.classList.remove('tridos-rp-open');
    Array.prototype.forEach.call(document.querySelectorAll(WIDGET), function (w) {
      var form = formOf(w);
      if (form) setBusy(form, false);
    });
    refreshForms(document);
  });
});

/* 053 — Filter bar on collection and search pages (snippets/tridos-filter-bar.liquid,
   custom.css block 053). Each filter's title becomes a pill; a tap opens its list (a
   pop-over on desktop, a bottom sheet on phones) with "Clear" and "Show N products".
   The filtering itself stays Streamline's: a tick fires theme.js's own `input` handler,
   which fetches the page and swaps the inner HTML of #CollectionFiltersSection. That swap
   throws away our pills, so a MutationObserver re-dresses the new markup and re-opens the
   list the shopper had open, with the focus and the list's scroll position put back.
   Wrapped in tridosBlock() like every block (PR #69). */
tridosBlock('053', function () {
  'use strict';

  var WRAP_ID = 'CollectionFiltersSection';
  var phone = window.matchMedia('(max-width: 768px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SLIDE_OUT_MS = 240; // custom.css: tridos-fb-down runs 0.22 s
  var openKey = null;     // title of the filter whose list is open
  // What to put back after the swap: { key, scroll, focus } — the list's scroll position
  // (phones scroll inside it) and the box ticked last, or 'pill' after "Clear".
  var restore = null;
  var inFlight = false;   // theme.js is fetching a result
  var clearing = false;
  var busyTimer = null;
  var observed = null;
  var backdrop = null;
  var X_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function wrapper() {
    var w = document.getElementById(WRAP_ID);
    return w && w.closest('.collection-filters') ? w : null;
  }

  function groups() {
    var w = wrapper();
    return w ? Array.prototype.slice.call(w.querySelectorAll('.collection-filter__group')) : [];
  }

  function titleOf(group) {
    return group.querySelector('.collection-filter__title');
  }

  function keyOf(group) {
    var t = titleOf(group);
    return t ? t.getAttribute('data-tridos-fb-group') : null;
  }

  function popOf(group) {
    return group.querySelector('.tridos-fb__pop');
  }

  function listOf(group) {
    return group.querySelector('.tridos-fb__pop .tag-list');
  }

  // Turn Streamline's title + list into a pill + a hidden list. Runs on load and after
  // every swap; a group that already has its pill is left alone.
  function dress() {
    var w = wrapper();
    if (!w) return;
    var tpl = w.querySelector('template[data-tridos-fb-foot]');
    var closeLabel = (tpl && tpl.getAttribute('data-close-label')) || 'Close';
    groups().forEach(function (group, i) {
      var title = titleOf(group);
      var inner = group.querySelector('.collection-filter__inner');
      if (!title || !inner || title.hasAttribute('data-tridos-fb-group')) return;
      var name = title.textContent.replace(/\s+/g, ' ').trim();

      var pop = document.createElement('div');
      pop.className = 'tridos-fb__pop';
      pop.id = 'tridos-fb-pop-' + i;
      pop.setAttribute('role', 'group');
      pop.setAttribute('aria-label', name);
      var head = document.createElement('div');
      head.className = 'tridos-fb__head';
      var headTitle = document.createElement('span');
      headTitle.textContent = name;
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'tridos-fb__x';
      x.setAttribute('data-tridos-fb-close', '');
      x.setAttribute('aria-label', closeLabel);
      x.innerHTML = X_ICON;
      head.appendChild(headTitle);
      head.appendChild(x);
      pop.appendChild(head);
      while (title.nextSibling) pop.appendChild(title.nextSibling);
      if (tpl) pop.appendChild(tpl.content.cloneNode(true));
      inner.appendChild(pop);

      if (group.querySelectorAll('li.tag:not(.hide)').length > 8) pop.classList.add('tridos-fb__pop--cols');

      title.setAttribute('data-tridos-fb-group', name);
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-expanded', 'false');
      title.setAttribute('aria-controls', pop.id);

      var picks = 0;
      Array.prototype.forEach.call(group.querySelectorAll('.tag__input'), function (input) {
        var label = input.closest('label');
        var text = label && label.querySelector('.tag__text');
        input.setAttribute('data-tridos-fb-value', name + ': ' + (text ? text.textContent.trim() : input.value));
        if (input.checked) picks++;
      });
      group.classList.toggle('has-picks', picks > 0);
      if (picks) {
        var n = document.createElement('span');
        n.className = 'tridos-fb__n';
        n.textContent = picks;
        title.appendChild(n);
      }
      var clear = pop.querySelector('[data-tridos-fb-clear]');
      if (clear) clear.disabled = picks === 0;
    });

    if (openKey) {
      var again = groups().filter(function (g) { return keyOf(g) === openKey; })[0];
      if (again) open(again, true);
      else close(false);
    }
  }

  function setOpen(group, on) {
    group.classList.toggle('is-open', on);
    var t = titleOf(group);
    if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  // Keep a desktop pop-over inside the window (the last pill on a narrow screen).
  function place(pop) {
    pop.style.left = '';
    var r = pop.getBoundingClientRect();
    var over = r.right - (document.documentElement.clientWidth - 16);
    if (over > 0) pop.style.left = -over + 'px';
  }

  function sheetMode(on) {
    if (on && !backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'tridos-fb__backdrop';
      backdrop.hidden = true;
      backdrop.addEventListener('click', function () { close(false); });
      document.body.appendChild(backdrop);
    }
    if (backdrop) {
      backdrop.hidden = !on;
      backdrop.classList.remove('is-leaving');
      backdrop.style.opacity = '';
    }
    document.documentElement.classList.toggle('tridos-fb-lock', on);
  }

  // A sheet that is sliding out finishes at once (another pill was opened meanwhile).
  function finishClosing(group) {
    if (!group.classList.contains('is-closing')) return;
    group.classList.remove('is-closing');
    setOpen(group, false);
    var pop = popOf(group);
    if (pop) pop.style.transform = '';
  }

  function open(group, restoring) {
    groups().forEach(function (g) {
      finishClosing(g);
      if (g !== group) setOpen(g, false);
    });
    setOpen(group, true);
    // After a pick theme.js redraws the list; it comes back in place, without the slide.
    group.classList.toggle('tridos-fb--still', !!restoring);
    openKey = keyOf(group);
    var pop = popOf(group);
    if (phone.matches) sheetMode(true);
    else if (pop) place(pop);
    if (!restoring) {
      restore = null;
      // A phone sheet takes the focus, so keyboard and screen-reader users land in it.
      var x = phone.matches && pop && pop.querySelector('[data-tridos-fb-close]');
      if (x) x.focus({ preventScroll: true });
      return;
    }
    var r = restore;
    restore = null;
    if (!r || r.key !== openKey) return;
    var list = listOf(group);
    if (list) list.scrollTop = r.scroll;
    if (r.focus === 'pill') {
      titleOf(group).focus({ preventScroll: true });
    } else if (r.focus) {
      var box = Array.prototype.filter.call(group.querySelectorAll('.tag__input'), function (input) {
        return input.name === r.focus.name && input.value === r.focus.value;
      })[0];
      if (box) box.focus({ preventScroll: true });
    }
  }

  // On a phone the sheet slides down and the backdrop fades before both go.
  function close(returnFocus) {
    var was = groups().filter(function (g) { return g.classList.contains('is-open') && !g.classList.contains('is-closing'); })[0];
    var slide = was && phone.matches && !still.matches;
    openKey = null;
    groups().forEach(function (g) { if (g !== was || !slide) setOpen(g, false); });
    if (slide) {
      was.classList.add('is-closing');
      titleOf(was).setAttribute('aria-expanded', 'false');
      if (backdrop) backdrop.classList.add('is-leaving');
      setTimeout(function () {
        finishClosing(was);
        if (!openKey) sheetMode(false);
      }, SLIDE_OUT_MS);
    } else {
      sheetMode(false);
    }
    if (returnFocus && was && titleOf(was)) titleOf(was).focus({ preventScroll: true });
  }

  function toggle(group) {
    if (group.classList.contains('is-open') && !group.classList.contains('is-closing')) close(false);
    else open(group, false);
  }

  // While theme.js fetches the result, the list is greyed out and further ticks and
  // "Clear" are refused (see the click listener): theme.js ignores input while it is
  // busy, so they would silently disappear on the swap. theme.js never recovers from a
  // failed fetch (no catch, it stays busy for good), so after 8 s without a swap the page
  // loads the picked filters the plain way.
  function busy(group) {
    var pop = popOf(group);
    var form = group.closest('form');
    inFlight = true;
    if (pop) pop.classList.add('is-busy');
    clearTimeout(busyTimer);
    busyTimer = setTimeout(function () {
      if (!form) return;
      var params = new URLSearchParams(new FormData(form));
      var current = new URLSearchParams(location.search);
      ['sort_by', 'q', 'type', 'options[prefix]'].forEach(function (k) {
        if (current.has(k)) params.set(k, current.get(k));
      });
      location.href = location.pathname + '?' + params.toString();
    }, 8000);
  }

  function clearGroup(group) {
    var ticked = Array.prototype.filter.call(group.querySelectorAll('.tag__input'), function (input) {
      return input.checked;
    });
    if (!ticked.length) return;
    ticked.forEach(function (input) { input.checked = false; });
    // theme.js reads the whole form, so one event carries every untick. The input
    // listener below sees it too; `clearing` makes it put the focus back on the pill.
    clearing = true;
    try {
      ticked[ticked.length - 1].dispatchEvent(new Event('input', { bubbles: true }));
    } finally {
      clearing = false;
    }
  }

  // Capture phase, before the browser ticks the box: refused while a result is loading.
  document.addEventListener('click', function (evt) {
    if (inFlight && evt.target && evt.target.matches && evt.target.matches('.collection-filters .tag__input')) {
      evt.preventDefault();
    }
  }, true);

  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest || !wrapper()) return;
    var title = t.closest('.collection-filters [data-tridos-fb-group]');
    if (title) {
      toggle(title.closest('.collection-filter__group'));
      return;
    }
    if (t.closest('.collection-filters [data-tridos-fb-close], .collection-filters [data-tridos-fb-show]')) {
      close(!phone.matches);
      return;
    }
    var clear = t.closest('.collection-filters [data-tridos-fb-clear]');
    if (clear) {
      if (!inFlight) clearGroup(clear.closest('.collection-filter__group'));
      return;
    }
    if (openKey && !phone.matches && !t.closest('.collection-filters .is-open')) close(false);
  });

  document.addEventListener('keydown', function (evt) {
    if (!openKey && evt.key === 'Escape') return;
    var t = evt.target;
    if ((evt.key === 'Enter' || evt.key === ' ') && t && t.matches && t.matches('.collection-filters [data-tridos-fb-group]')) {
      evt.preventDefault();
      toggle(t.closest('.collection-filter__group'));
    } else if (evt.key === 'Escape' && openKey) {
      close(true);
    } else if (evt.key === 'Tab' && openKey && phone.matches) {
      // Keep the focus inside the open sheet; the page behind the backdrop is inert.
      var group = groups().filter(function (g) { return g.classList.contains('is-open'); })[0];
      var pop = group && popOf(group);
      if (!pop) return;
      var stops = Array.prototype.filter.call(pop.querySelectorAll('button, input'), function (el) {
        return !el.disabled && el.getClientRects().length > 0;
      });
      if (!stops.length) return;
      var first = stops[0];
      var last = stops[stops.length - 1];
      if (!pop.contains(document.activeElement) || (evt.shiftKey && document.activeElement === first)) {
        evt.preventDefault();
        (evt.shiftKey ? last : first).focus();
      } else if (!evt.shiftKey && document.activeElement === last) {
        evt.preventDefault();
        first.focus();
      }
    }
  });

  // Desktop: tabbing out of an open pop-over closes it.
  document.addEventListener('focusin', function (evt) {
    if (!openKey || phone.matches) return;
    var t = evt.target;
    if (t && t.closest && !t.closest('.collection-filters .is-open')) close(false);
  });

  // Capture phase: runs before theme.js starts the fetch for this tick.
  document.addEventListener('input', function (evt) {
    var input = evt.target;
    if (!input || !input.matches || !input.matches('.collection-filters .tag__input')) return;
    var group = input.closest('.collection-filter__group');
    if (!group) return;
    var list = listOf(group);
    restore = {
      key: keyOf(group),
      scroll: list ? list.scrollTop : 0,
      focus: clearing ? 'pill' : { name: input.name, value: input.value }
    };
    busy(group);
  }, true);

  phone.addEventListener && phone.addEventListener('change', function () { close(false); });

  // The handle: drag the sheet's head down to close it. A short drag springs back.
  var drag = null;
  document.addEventListener('pointerdown', function (evt) {
    var t = evt.target;
    if (!openKey || !phone.matches || !t || !t.closest) return;
    var head = t.closest('.collection-filters .is-open .tridos-fb__head');
    if (!head || t.closest('[data-tridos-fb-close]')) return;
    var pop = head.closest('.tridos-fb__pop');
    drag = { pop: pop, id: evt.pointerId, y0: evt.clientY, dy: 0, t0: Date.now() };
    pop.classList.add('is-dragging');
    try { head.setPointerCapture(evt.pointerId); } catch (err) {}
  });
  document.addEventListener('pointermove', function (evt) {
    if (!drag || evt.pointerId !== drag.id) return;
    drag.dy = Math.max(0, evt.clientY - drag.y0);
    drag.pop.style.transform = 'translateY(' + drag.dy + 'px)';
    if (backdrop) backdrop.style.opacity = String(Math.max(0, 1 - drag.dy / drag.pop.offsetHeight));
  });
  function endDrag(evt) {
    if (!drag || evt.pointerId !== drag.id) return;
    var d = drag;
    drag = null;
    d.pop.classList.remove('is-dragging');
    var fast = d.dy > 20 && d.dy / Math.max(1, Date.now() - d.t0) > 0.5;
    if (evt.type === 'pointerup' && (d.dy > Math.min(120, d.pop.offsetHeight / 4) || fast)) {
      close(false);
      return;
    }
    d.pop.style.transition = 'transform 0.2s ease';
    d.pop.style.transform = '';
    if (backdrop) backdrop.style.opacity = '';
    setTimeout(function () { d.pop.style.transition = ''; }, 220);
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  function watch() {
    var w = wrapper();
    if (!w || w === observed || !window.MutationObserver) return;
    observed = w;
    new MutationObserver(function () {
      clearTimeout(busyTimer);
      inFlight = false;
      dress();
    }).observe(w, { childList: true });
  }

  function init() {
    dress();
    watch();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // The theme editor re-renders the whole section, wrapper included.
  document.addEventListener('shopify:section:load', function () {
    openKey = null;
    inFlight = false;
    clearTimeout(busyTimer);
    sheetMode(false);
    init();
  });
});

/* 055 — "See the difference": two thermal clips, one Old/New switch
   (sections/tridos-video-compare.liquid, custom.css block 055).
   Both clips are stacked and play at once; the switch only changes which one is visible,
   so a tap shows the other monocular at the same moment of the scene. The clips load only
   when the section comes near the screen (1.2 MB each) and pause when it leaves. The new
   clip leads. The old one follows: a small drift is closed by playing it 5% faster or
   slower (no visible jump), only a big one (over 0.5 s) jumps it to the new clip's time;
   the gap is measured across the loop point, so one clip restarting a moment before the
   other is not a drift. The picture flips by itself every 2 seconds until the shopper
   taps Old or New. Reduced-motion settings load the clips paused (first frame shown),
   without the flip. A browser that refuses to start them (an iPhone in Low Power Mode)
   leaves them paused with the button on "Play", so one tap starts them. Each control's
   data-tvc-action names what its next tap does, for the 051 tracking. */
tridosBlock('055', function () {
  'use strict';

  Array.prototype.forEach.call(document.querySelectorAll('[data-tvc]'), function (root) {
    var lead = root.querySelector('video[data-role="new"]');
    var follow = root.querySelector('video[data-role="old"]');
    var box = root.querySelector('[data-tvc-box]');
    var autoBtn = root.querySelector('[data-tvc-auto]');
    var pauseBtn = root.querySelector('[data-tvc-pause]');
    if (!lead || !follow || !box || !autoBtn || !pauseBtn) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var userPaused = reduceMotion;
    var inView = false;
    var timer = null;

    function load(v) {
      if (!v.getAttribute('src')) {
        v.preload = 'auto';
        // #t= makes Safari draw the first frame of a paused clip (there is no poster).
        v.src = v.getAttribute('data-src') + '#t=0.001';
      }
    }

    function labels() {
      pauseBtn.textContent = pauseBtn.getAttribute(userPaused ? 'data-label-play' : 'data-label-pause');
      pauseBtn.setAttribute('data-tvc-action', userPaused ? 'play' : 'pause');
      autoBtn.setAttribute('data-tvc-action', autoBtn.getAttribute('aria-checked') === 'true' ? 'turn_off' : 'turn_on');
    }

    function refused() {
      if (userPaused) return;
      userPaused = true;
      lead.pause();
      follow.pause();
      labels();
      setAuto();
    }

    function play(v) {
      var p = v.play();
      if (p && p.catch) p.catch(function (err) {
        // AbortError = a pause() came first (the shopper scrolled away): not a refusal.
        if (!err || err.name !== 'AbortError') refused();
      });
    }

    function setAuto() {
      clearInterval(timer);
      timer = null;
      if (inView && !userPaused && autoBtn.getAttribute('aria-checked') === 'true') {
        timer = setInterval(function () {
          show(box.getAttribute('data-show') === 'new' ? 'old' : 'new');
        }, 2000);
      }
    }

    function sync() {
      if (inView) {
        load(lead);
        load(follow);
      }
      if (inView && !userPaused) {
        play(lead);
        play(follow);
      } else {
        lead.pause();
        follow.pause();
      }
      labels();
      setAuto();
    }

    function show(which) {
      box.setAttribute('data-show', which);
      Array.prototype.forEach.call(root.querySelectorAll('[data-tvc-show]'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-tvc-show') === which ? 'true' : 'false');
      });
    }

    lead.addEventListener('timeupdate', function () {
      if (follow.seeking || follow.readyState < 2 || follow.paused) return;
      var gap = lead.currentTime - follow.currentTime;
      var len = lead.duration;
      if (len && isFinite(len) && Math.abs(gap) > len / 2) gap -= gap > 0 ? len : -len;
      if (Math.abs(gap) > 0.5) {
        follow.playbackRate = 1;
        follow.currentTime = lead.currentTime;
      } else if (Math.abs(gap) > 0.04) {
        follow.playbackRate = gap > 0 ? 1.05 : 0.95;
      } else {
        follow.playbackRate = 1;
      }
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-tvc-show]'), function (b) {
      b.addEventListener('click', function () {
        autoBtn.setAttribute('aria-checked', 'false');
        show(b.getAttribute('data-tvc-show'));
        labels();
        setAuto();
      });
    });

    autoBtn.addEventListener('click', function () {
      autoBtn.setAttribute('aria-checked', autoBtn.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
      labels();
      setAuto();
    });

    pauseBtn.addEventListener('click', function () {
      userPaused = !userPaused;
      sync();
    });

    if (reduceMotion) autoBtn.setAttribute('aria-checked', 'false');

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        // A fast scroll can batch "entered" and "left": the last entry is the current state.
        inView = entries[entries.length - 1].isIntersecting;
        sync();
      }, { rootMargin: '200px 0px' }).observe(root);
    } else {
      inView = true;
    }
    labels();
    if (inView) sync();
  });
});

/* 054 — Product dropdowns: the Shipping title's "fulfilled in 1–2 days" hint follows the
   selected variant. snippets/tab.liquid lists the variants that can ship now
   (data-tridos-ship-ids=",id,id,") and renders the hint hidden when the first selected
   variant is not one of them; this keeps it true when the shopper picks another one.
   A combination that does not exist (variant null) hides it. */
tridosBlock('054', function () {
  tridosOnVariantChange('054', function (section, variant) {
    Array.prototype.forEach.call(section.querySelectorAll('[data-tridos-ship-ids]'), function (hint) {
      hint.hidden = !(variant && hint.getAttribute('data-tridos-ship-ids').indexOf(',' + variant.id + ',') !== -1);
    });
  });
});

/* TRIDOS-CUSTOM 057 — "Complete your upgrade" card (sections/tridos-bought-together.liquid):
   tick boxes drive the total and the button count, a partner's variant chip changes its
   price, this product's row follows the main form's variant, and "Add all" puts every
   ticked item in the cart in one request. On success the theme's own ajaxProduct:added
   is fired per item, so the cart drawer redraws and opens exactly as after Add to cart
   (the same path register 052 uses for its parts). Fails open: a failed request shows
   the theme-worded error under the button and leaves the ticks as they were. */
tridosBlock('057', function () {
  'use strict';

  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-tridos-bt]'));
  if (!roots.length) return;

  function money(cents) {
    return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
  }

  function rows(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-bt-row]'));
  }

  // The chosen variant of a row: id and price in cents.
  function pick(row) {
    var v = row.querySelector('[data-bt-variant]');
    if (!v) return null;
    var carrier = v.tagName === 'SELECT' ? v.options[v.selectedIndex] : v;
    if (!carrier) return null;
    return { id: parseInt(v.value, 10), price: parseInt(carrier.getAttribute('data-price'), 10) || 0 };
  }

  function fill(el, count) {
    if (!el) return;
    if (count === 0 && el.getAttribute('data-bt-label-zero')) {
      el.textContent = el.getAttribute('data-bt-label-zero');
      return;
    }
    var tpl = (count === 1 && el.getAttribute('data-bt-label-one')) || el.getAttribute('data-bt-label');
    if (tpl) el.textContent = tpl.replace('%d', String(count));
  }

  // A row whose product was just added anywhere on the page (the main form, a quick-shop
  // pop-up, 052's parts): unticked and "In your cart", so "Add all" cannot add it again.
  function markRowInCart(root, productId) {
    var row = root.querySelector('[data-bt-row][data-bt-product="' + productId + '"]');
    var tick = row && row.querySelector('[data-bt-tick]');
    // A row that cannot be ticked here (sold out, needs a check) already says why.
    if (!row || !tick || tick.disabled) return;
    tick.checked = false;
    row.setAttribute('data-bt-held', '');
    row.removeAttribute('data-bt-user');
    var text = row.querySelector('.tridos-bt__text');
    if (text && !row.querySelector('[data-bt-cart-note]') && !row.hasAttribute('data-bt-check')) {
      var note = document.createElement('span');
      note.className = 'tridos-bt__note';
      note.setAttribute('data-bt-cart-note', '');
      note.textContent = root.getAttribute('data-bt-in-cart') || '';
      text.appendChild(note);
    }
    refresh(root);
  }

  // The button needs at least one partner ticked: this item alone is what the main
  // form already sells, and "Add all 1" would read wrong anyway.
  function refresh(root) {
    var count = 0;
    var partnersOn = 0;
    var total = 0;
    rows(root).forEach(function (row) {
      var tick = row.querySelector('[data-bt-tick]');
      var v = pick(row);
      var price = row.querySelector('[data-bt-row-price]');
      if (price && v) price.innerHTML = money(v.price);
      var on = !!(tick && tick.checked);
      // Read by the usage tracking (051) on the next tap: "on" means that tap unticks.
      if (tick) tick.setAttribute('data-bt-state', on ? 'on' : 'off');
      row.classList.toggle('is-off', !on);
      if (on && v) {
        count += 1;
        total += v.price;
        if (!row.hasAttribute('data-bt-self')) partnersOn += 1;
      }
    });
    var totalEl = root.querySelector('[data-bt-total]');
    if (totalEl) totalEl.innerHTML = money(total);
    fill(root.querySelector('[data-bt-total-label]'), count);
    var btn = root.querySelector('[data-bt-add]');
    if (btn && !root[BUSY]) {
      // No partner ticked: the button is off and says what to do, not "Add 1 item".
      fill(btn, partnersOn === 0 ? 0 : count);
      btn.disabled = partnersOn === 0;
    }
  }

  // A failed add: Shopify's own words when it gave any, else the general line.
  function showError(root, text) {
    var err = root.querySelector('[data-bt-error]');
    if (!err) return;
    err.textContent = text || root.getAttribute('data-bt-failed') || '';
    err.hidden = !err.textContent;
  }

  function clearError(root) {
    var err = root.querySelector('[data-bt-error]');
    if (!err) return;
    err.textContent = '';
    err.hidden = true;
  }

  var BUSY = '_tridosBtBusy';

  function addAll(root, btn) {
    if (btn.disabled || root[BUSY]) return;
    var items = [];
    rows(root).forEach(function (row) {
      var tick = row.querySelector('[data-bt-tick]');
      var v = pick(row);
      if (tick && tick.checked && v && v.id) items.push({ id: v.id, quantity: 1 });
    });
    if (!items.length) return;
    clearError(root);
    root[BUSY] = true;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-bt-adding') || '';
    function done() {
      root[BUSY] = false;
      refresh(root);
    }
    fetch(theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          done();
          showError(root, res.body && (res.body.description || res.body.message));
          return;
        }
        // One event per added line: the cart drawer redraws, and the card's own listener
        // marks exactly those rows "In your cart" (not whatever is ticked by now).
        (res.body.items || []).forEach(function (item) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } }));
        });
        done();
      })
      .catch(function () {
        done();
        showError(root, '');
      });
  }

  roots.forEach(function (root) {
    root.addEventListener('change', function (evt) {
      var t = evt.target;
      if (!t) return;
      // Remember the shopper's own choice on this item, so a variant change keeps it.
      if (t.hasAttribute('data-bt-tick') && t.closest('[data-bt-self]')) {
        t.closest('[data-bt-self]').setAttribute('data-bt-user', t.checked ? 'on' : 'off');
      }
      if (t.hasAttribute('data-bt-tick') || t.hasAttribute('data-bt-variant')) refresh(root);
    });
    var btn = root.querySelector('[data-bt-add]');
    if (btn) btn.addEventListener('click', function () { addAll(root, btn); });
    refresh(root);
  });

  // Something on the page added a product (theme.js and 052 fire ajaxProduct:added with
  // the line in detail.product): if it is on the card, the card must not add it again.
  document.addEventListener('ajaxProduct:added', function (evt) {
    var line = evt.detail && evt.detail.product;
    if (!line || !line.product_id) return;
    roots.forEach(function (root) {
      markRowInCart(root, String(line.product_id));
    });
  });

  // Back to this page from the browser history: the page comes back exactly as it was
  // left, so anything added on another page in between is not marked yet. Ask the cart.
  window.addEventListener('pageshow', function (evt) {
    if (!evt.persisted) return;
    fetch(theme.routes.cart + '?t=' + Date.now(), { credentials: 'same-origin' }) // routes.cart is /cart.js
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        (cart.items || []).forEach(function (line) {
          roots.forEach(function (root) { markRowInCart(root, String(line.product_id)); });
        });
      })
      .catch(function () {});
  });

  // This product's row follows the variant chosen in the main form — the main product
  // section only: a quick-shop pop-up for another product fires the same event (the
  // variant objects carry no product id, so the section is what tells them apart).
  tridosOnVariantChange('057', function (section, variant) {
    if (section.getAttribute('data-modal') === 'true' || (section.closest && section.closest('[data-modal="true"]'))) return;
    var sectionProduct = section.getAttribute('data-product-id');
    roots.forEach(function (root) {
      if (sectionProduct && sectionProduct !== root.getAttribute('data-product-id')) return;
      var row = root.querySelector('[data-bt-self]');
      var self = row && row.querySelector('[data-bt-variant]');
      var tick = row && row.querySelector('[data-bt-tick]');
      if (!self || !tick) return;
      // No variant for this combination, or a sold-out one: out of the request (Shopify
      // refuses the whole batch when one line cannot be added), shown as out of stock.
      var sellable = !!variant && variant.available !== false && variant.price > 0;
      if (variant) {
        self.value = String(variant.id);
        self.setAttribute('data-price', String(variant.price));
      }
      if (row.hasAttribute('data-bt-check')) {
        // Added by the main button, never here: no tick — but its price and stock follow.
        tick.disabled = true;
        tick.checked = false;
      } else {
        tick.disabled = !sellable;
        // The shopper's own tick or untick wins; otherwise a row they already have (in
        // the cart, bought lately) starts unticked.
        var user = row.getAttribute('data-bt-user');
        tick.checked = sellable && (user === 'on' || (user !== 'off' && !row.hasAttribute('data-bt-held')));
      }
      row.classList.toggle('is-soldout', !sellable);
      // "Out of stock" only when it is: a free variant is just not offered here.
      var note = root.querySelector('[data-bt-self-soldout]');
      if (note) note.hidden = !variant || variant.available !== false;
      refresh(root);
    });
  });
});

/* 059 — "How close is too close?": the BB energy check on the thermal protector pages
   (sections/tridos-bb-check.liquid, custom.css block 059).
   Physics: a trimmed copy of the BB energy calculator (Mikus's bb-energy-calculator): RK4
   steps of 0.1 ms, drag Cd 0.40, hop-up spin lift (KL 0.30, spin decay 0.02) tuned flat
   (lift = weight at the muzzle), air at 25 °C and sea level, muzzle 1.5 m above the ground.
   The weight slider stops only at weights that are sold (BLS, Novritsch). The picture is
   a side view: the rifle, the flight path, the ground with 0/25/50/75 m marks; distance
   is stretched near the muzzle (power 0.7) so short distances stay readable, and the
   pointer read-out inverts that stretch. The path colour follows the energy: red above
   the single-impact limit (data-single, 2.0 J), red → yellow → green between the two
   limits, green from the multiple-impact limit (data-limit, 1.5 J). The white line and
   the headline give that last distance, always rounded UP (never closer than the model).
   Mouse: the read-out follows the pointer and hides when it leaves. Touch: a tap or drag
   shows it above the finger; a tap outside the picture hides it. */
tridosBlock('059', function () {
  'use strict';

  var G = 9.80665, D = 0.00595, R = D / 2, AREA = Math.PI * R * R;
  var KL = 0.30, CS = 0.02, DX = 0.1, XMAX = 200, DT = 1e-4, EPS = 1e-9;
  var RHO = 101325 / (287.05 * (25 + 273.15)); // 25 °C, sea level
  var CD0 = 0.40, H0 = 1.5, FPS = 3.28084;
  var WEIGHTS = [0.20, 0.23, 0.25, 0.28, 0.30, 0.32, 0.36, 0.40, 0.43, 0.45, 0.46, 0.48, 0.49];
  var STRETCH = 0.7;
  // Rifle silhouette (assets/tridos-bb-rifle.png): pixel size and the muzzle point in it.
  var RIFLE = { w: 731, h: 267, mx: 728, my: 81 };

  function isAbove(e, thr) { return e > thr + EPS; }

  // State s = [x, y, vx, vy, spin]; one RK4 step updates it in place. Preallocated
  // buffers: a shot is ~20 000 steps, re-run on every slider move.
  var K1 = new Float64Array(5), K2 = new Float64Array(5), K3 = new Float64Array(5), K4 = new Float64Array(5), T = new Float64Array(5);
  function deriv(s, m, o) {
    var vx = s[2], vy = s[3], w = s[4], v = Math.hypot(vx, vy);
    var cl = KL * (w * R) / v, k = (0.5 * RHO * AREA * v) / m;
    o[0] = vx; o[1] = vy;
    o[2] = k * (-CD0 * vx - cl * vy);
    o[3] = k * (-CD0 * vy + cl * vx) - G;
    o[4] = -(w * CS * RHO * AREA * v) / (0.4 * m);
  }
  function rk4(s, h, m) {
    var i;
    deriv(s, m, K1);
    for (i = 0; i < 5; i++) T[i] = s[i] + K1[i] * (h / 2);
    deriv(T, m, K2);
    for (i = 0; i < 5; i++) T[i] = s[i] + K2[i] * (h / 2);
    deriv(T, m, K3);
    for (i = 0; i < 5; i++) T[i] = s[i] + K3[i] * h;
    deriv(T, m, K4);
    for (i = 0; i < 5; i++) s[i] = s[i] + (h / 6) * (K1[i] + 2 * K2[i] + 2 * K3[i] + K4[i]);
  }
  // One shot: samples every 0.1 m (height, energy) until the BB reaches the ground,
  // where its energy drops to thr (cross), and where it lands.
  function simulate(massG, v0, thr) {
    var m = massG / 1000;
    var w0 = (m * G) / (0.5 * RHO * AREA * KL * R * v0);
    var s = new Float64Array([0, 0, v0, 0, w0]), t = 0, e0 = 0.5 * m * v0 * v0;
    var S = [{ x: 0, y: 0, e: e0 }], nextX = DX, landX = null, cross = null, prevE = e0;
    while (s[0] < XMAX && t < 12) {
      var px = s[0], py = s[1], pv = Math.hypot(s[2], s[3]);
      rk4(s, DT, m); t += DT;
      var x = s[0], y = s[1], nv = Math.hypot(s[2], s[3]), e = 0.5 * m * nv * nv;
      if (cross === null && isAbove(prevE, thr) && !isAbove(e, thr)) cross = px + ((x - px) * (prevE - thr)) / (prevE - e);
      if (landX === null && y <= -H0) landX = px + (x - px) * ((py + H0) / (py - y));
      while (nextX <= x) {
        var fr = (nextX - px) / (x - px), vv = pv + (nv - pv) * fr;
        S.push({ x: nextX, y: py + (y - py) * fr, e: 0.5 * m * vv * vv });
        nextX = Math.round((nextX + DX) * 1e6) / 1e6;
      }
      prevE = e;
      if (s[2] <= 0.5 || landX !== null) break; // the picture stops at the ground
    }
    if (cross !== null && landX !== null && cross > landX) cross = null;
    return { S: S, cross: cross, landX: landX, everAbove: isAbove(e0, thr) };
  }
  // Height (k = 'y') or energy (k = 'e') at distance x, between two samples.
  function sample(S, x, k) {
    var i = Math.max(0, Math.min(S.length - 1, Math.floor(x / DX))), a = S[i], b = S[Math.min(S.length - 1, i + 1)];
    return a[k] + (b.x > a.x ? (b[k] - a[k]) * (x - a.x) / (b.x - a.x) : 0);
  }

  function fix(x, d) { return Number.isFinite(x) ? x.toFixed(d) : '–'; }
  function upTo10cm(x) { return (Math.ceil(x * 10 - 1e-9) / 10).toFixed(1); } // always round UP
  function cssVar(el, name) { return getComputedStyle(el).getPropertyValue(name).trim(); }
  function rgb(hex) { var n = parseInt(hex.replace('#', ''), 16); return [n >> 16, (n >> 8) & 255, n & 255]; }
  function mix(a, b, t) { t = Math.max(0, Math.min(1, t)); return 'rgb(' + a.map(function (v, i) { return Math.round(v + (b[i] - v) * t); }).join(',') + ')'; }

  function draw(root, st) {
    var svg = root.querySelector('.tridos-bbc__svg');
    var W = Math.max(280, svg.clientWidth || 700), H = Math.max(160, svg.clientHeight || 300);
    var c = {};
    ['bad', 'mid', 'good', 'line', 'ground', 'bb', 'muted'].forEach(function (n) { c[n] = cssVar(root, '--tridos-bbc-' + n); });
    var res = st.res, S = res.S, phone = W < 560;
    var Gy = H - (phone ? 26 : 34);                      // the ground
    var top = phone ? 46 : 56;                           // room for the distance label
    var hPx = (Gy - top) * (phone ? 0.6 : 0.72);         // the muzzle, 1.5 m above the ground
    var k = hPx / H0, My = Gy - hPx;
    var L = Math.max(90, Math.min(240, W * 0.2));        // rifle width, butt to muzzle
    var GAP = phone ? 6 : 10;                            // space between the muzzle and the path
    var Mx = (phone ? 8 : 22) + L + GAP;
    var pw = W - Mx - (phone ? 16 : 30);
    var xView = res.landX || S[S.length - 1].x;
    function X(x) { return Mx + pw * Math.pow(Math.max(0, x) / xView, STRETCH); }
    function Y(y) { return Math.min(Gy, My - y * k); }
    function at(x) { return sample(S, x, 'y'); }
    function eAt(x) { return sample(S, x, 'e'); }
    var B = rgb(c.bad), M = rgb(c.mid), Gd = rgb(c.good), hi = st.single, lo = st.thr;
    function colE(e) {
      if (e >= hi) return c.bad;
      if (e <= lo) return c.good;
      var t = (hi - e) / (hi - lo);
      return t < 0.5 ? mix(B, M, t * 2) : mix(M, Gd, (t - 0.5) * 2);
    }
    var pts = S.filter(function (p) { return p.x < xView; }).map(function (p) { return [p.x, p.y]; });
    pts.push([xView, -H0]);
    var path = pts.map(function (p, i) { return (i ? 'L' : 'M') + X(p[0]).toFixed(1) + ',' + Y(p[1]).toFixed(1); }).join('');
    var cross = res.everAbove && res.cross > 0 && res.cross < xView ? res.cross : 0;

    var g = '<defs><linearGradient id="tridos-bbc-grad-' + st.id + '" gradientUnits="userSpaceOnUse" x1="' + Mx.toFixed(1) + '" y1="0" x2="' + (Mx + pw).toFixed(1) + '" y2="0">';
    for (var n = 0; n <= 80; n++) {
      var u = n / 80;
      g += '<stop offset="' + u.toFixed(4) + '" stop-color="' + colE(eAt(xView * Math.pow(u, 1 / STRETCH))) + '"/>';
    }
    g += '</linearGradient></defs>';
    g += '<line x1="0" x2="' + W + '" y1="' + Gy + '" y2="' + Gy + '" stroke="' + c.ground + '" stroke-width="2"/>';
    [0, 25, 50, 75].forEach(function (d) {
      if (d > xView) return;
      var tx = X(d).toFixed(1);
      g += '<line x1="' + tx + '" x2="' + tx + '" y1="' + Gy + '" y2="' + (Gy + 6) + '" stroke="' + c.muted + '" stroke-width="1.5"/>';
      g += '<text class="tridos-bbc__tick" x="' + tx + '" y="' + (Gy + 20) + '" text-anchor="middle" fill="' + c.muted + '">' + d + ' m</text>';
    });
    var rs = L / RIFLE.mx, gun = root.getAttribute('data-gun');
    if (gun) g += '<image href="' + gun + '" x="' + (Mx - GAP - RIFLE.mx * rs).toFixed(1) + '" y="' + (My - RIFLE.my * rs).toFixed(1) + '" width="' + (RIFLE.w * rs).toFixed(1) + '" height="' + (RIFLE.h * rs).toFixed(1) + '"/>';
    g += '<path d="' + path + '" fill="none" stroke="url(#tridos-bbc-grad-' + st.id + ')" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>';
    g += '<circle cx="' + X(xView).toFixed(1) + '" cy="' + Gy + '" r="4" fill="' + colE(eAt(xView)) + '"/>';
    if (cross) {
      var lx = X(cross), ly = Y(at(cross)), tx2 = Math.max(30, Math.min(W - 30, lx));
      g += '<line x1="' + lx.toFixed(1) + '" x2="' + lx.toFixed(1) + '" y1="' + (top - 10) + '" y2="' + Gy + '" stroke="' + c.line + '" stroke-width="2"/>';
      g += '<circle cx="' + lx.toFixed(1) + '" cy="' + ly.toFixed(1) + '" r="6" fill="' + c.line + '"/>';
      g += '<text x="' + tx2.toFixed(1) + '" y="' + (top - 18) + '" text-anchor="middle" fill="' + c.line + '" class="tridos-bbc__lbl">' + upTo10cm(cross) + ' m</text>';
    }
    if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      g += '<circle r="4" fill="' + c.bb + '"><animateMotion dur="2.4s" repeatCount="indefinite" calcMode="linear" path="' + path + '"/></circle>';
    }
    // (one literal per piece: Shopify's minifier joins adjacent literals, which the CI sync
    // check, tests/scripts/wait-for-sync.mjs, would read as a different file)
    g += '<g class="tridos-bbc__hv" visibility="hidden"><line y1="' + (top - 10) + '" y2="' + Gy + '" stroke="' + c.line + '" stroke-width="1" stroke-dasharray="3 4" opacity=".6"/><circle r="6" stroke="' + c.line + '" stroke-width="2"/></g>';
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.innerHTML = g;
    st.geo = { W: W, Mx: Mx, pw: pw, xView: xView, X: X, Y: Y, at: at, eAt: eAt, col: colE };
  }

  function setup(root, id) {
    var thr = parseFloat(root.getAttribute('data-limit')) || 1.5;
    var single = parseFloat(root.getAttribute('data-single')) || 2.0;
    if (single < thr) single = thr;
    var wIn = root.querySelector('[data-in="w"]'), jIn = root.querySelector('[data-in="j"]');
    var svg = root.querySelector('.tridos-bbc__svg'), tip = root.querySelector('.tridos-bbc__tip');
    var safeEl = root.querySelector('[data-o="safe"]');
    if (!wIn || !jIn || !svg || !tip || !safeEl) return;
    var tSafe = root.getAttribute('data-t-safe'), tAny = root.getAttribute('data-t-any'), tNever = root.getAttribute('data-t-never');
    var st = null, cache = {}, queued = false, kx = null, ro = null;
    var srEl = root.querySelector('[data-o="sr"]');
    wIn.max = String(WEIGHTS.length - 1);

    function out(name, text) { var el = root.querySelector('[data-o="' + name + '"]'); if (el) el.textContent = text; }
    function fill(input) { input.style.setProperty('--p', ((input.value - input.min) / (input.max - input.min)) * 100 + '%'); }
    function headline(lead, strong, bad) {
      safeEl.textContent = '';
      if (lead) safeEl.appendChild(document.createTextNode(lead + ' '));
      var b = document.createElement('b'); b.textContent = strong; safeEl.appendChild(b);
      safeEl.classList.toggle('is-bad', !!bad);
    }
    function update() {
      var w = WEIGHTS[Math.max(0, Math.min(WEIGHTS.length - 1, parseInt(wIn.value, 10) || 0))];
      var J = parseFloat(jIn.value) || 2;
      var v0 = Math.sqrt((2 * J) / (w / 1000));
      var key = w + '|' + J, res = cache[key] || (cache[key] = simulate(w, v0, thr));
      st = { res: res, thr: thr, single: single, id: id };
      fill(wIn); fill(jIn);
      out('wChip', fix(w, 2) + ' g'); wIn.setAttribute('aria-valuetext', fix(w, 2) + ' g');
      out('jChip', fix(J, 1) + ' J'); jIn.setAttribute('aria-valuetext', fix(J, 1) + ' J');
      // only the number: "≈" and "fps" are in the markup (the minifier escapes a ≈ typed
      // here, and the CI sync check, tests/scripts/wait-for-sync.mjs, then never matches)
      out('conv', fix(v0 * FPS, 0));
      if (!res.everAbove) headline(tSafe, tAny);
      else if (res.cross) headline(tSafe, upTo10cm(res.cross) + ' m');
      else headline('', tNever, true);
      hide();
      draw(root, st);
    }

    function hide() {
      kx = null;
      tip.style.display = 'none';
      var lb = svg.querySelector('.tridos-bbc__lbl'); if (lb) lb.style.opacity = '';
      var hv = svg.querySelector('.tridos-bbc__hv'); if (hv) hv.setAttribute('visibility', 'hidden');
    }
    function show(evt) {
      if (!st || !st.geo) return;
      var g = st.geo, r = svg.getBoundingClientRect();
      if (!r.width) return;
      var u = Math.max(0, Math.min(1, (((evt.clientX - r.left) / r.width) * g.W - g.Mx) / g.pw));
      showAt(g.xView * Math.pow(u, 1 / STRETCH), evt.pointerType === 'touch' ? 44 : 16);
    }
    // The read-out at distance x; lift = gap above the point (more for a finger).
    function showAt(x, lift) {
      var g = st.geo, r = svg.getBoundingClientRect();
      if (!r.width) return null;
      kx = x;
      var e = g.eAt(x), colr = g.col(e);
      var px = g.X(x), py = g.Y(g.at(x));
      var hv = svg.querySelector('.tridos-bbc__hv'), line = hv.querySelector('line'), dot = hv.querySelector('circle');
      hv.setAttribute('visibility', 'visible');
      line.setAttribute('x1', px); line.setAttribute('x2', px);
      dot.setAttribute('cx', px); dot.setAttribute('cy', py); dot.setAttribute('fill', colr);
      tip.textContent = '';
      var i = document.createElement('i'); i.style.background = colr;
      var b = document.createElement('b'); b.textContent = (x < 10 ? fix(x, 1) : fix(x, 0)) + ' m';
      tip.appendChild(i); tip.appendChild(b); tip.appendChild(document.createTextNode(' · ' + fix(e, 2) + ' J'));
      tip.style.display = 'block';
      var scale = r.width / g.W, sr = tip.parentNode.getBoundingClientRect(), pad = 8;
      var left = r.left - sr.left + px * scale, topPx = r.top - sr.top + py * scale;
      left = Math.max(pad, Math.min(sr.width - tip.offsetWidth - pad, left - tip.offsetWidth / 2));
      // above the point; for touch higher, so the finger does not cover it
      tip.style.left = left + 'px';
      tip.style.top = Math.max(pad, topPx - tip.offsetHeight - lift) + 'px';
      var lb = svg.querySelector('.tridos-bbc__lbl');
      if (lb) {
        var a = tip.getBoundingClientRect(), l = lb.getBoundingClientRect();
        lb.style.opacity = a.left < l.right + 4 && a.right > l.left - 4 && a.top < l.bottom + 4 && a.bottom > l.top - 4 ? '0.15' : '';
      }
      return tip.textContent;
    }
    // Keyboard: the picture takes focus; arrows move the read-out (0.5 m steps under
    // 10 m, 1 m after; Shift x5), Home / End jump to the ends. Read out to screen readers.
    function onKey(evt) {
      if (!st || !st.geo) return;
      var g = st.geo, x = kx == null ? 0 : kx, step = (x < 10 ? 0.5 : 1) * (evt.shiftKey ? 5 : 1);
      if (evt.key === 'ArrowRight' || evt.key === 'ArrowUp') x += step;
      else if (evt.key === 'ArrowLeft' || evt.key === 'ArrowDown') x -= step;
      else if (evt.key === 'Home') x = 0;
      else if (evt.key === 'End') x = g.xView;
      else return;
      evt.preventDefault();
      say(showAt(Math.max(0, Math.min(g.xView, x)), 16));
    }
    function onFocus() {
      if (!st || !st.geo || !svg.matches(':focus-visible')) return;
      var c = st.res.everAbove && st.res.cross > 0 && st.res.cross < st.geo.xView ? st.res.cross : 0;
      say(showAt(kx == null ? c : Math.min(kx, st.geo.xView), 16));
    }
    function say(text) { if (srEl && text) srEl.textContent = text; }
    svg.addEventListener('pointermove', show);
    svg.addEventListener('pointerdown', show);
    svg.addEventListener('pointerleave', function (evt) { if (evt.pointerType === 'mouse') hide(); });
    svg.addEventListener('pointercancel', hide); // the touch became a page scroll
    svg.addEventListener('keydown', onKey);
    svg.addEventListener('focus', onFocus);
    svg.addEventListener('blur', hide);
    function onDocDown(evt) { if (!svg.contains(evt.target)) hide(); }
    document.addEventListener('pointerdown', onDocDown);
    // the theme editor removes and re-adds a section on every change: drop the
    // document listener and the size watcher with it
    function onUnload(evt) {
      if (!evt.target || !evt.target.contains(root)) return;
      document.removeEventListener('pointerdown', onDocDown);
      document.removeEventListener('shopify:section:unload', onUnload);
      if (ro) ro.disconnect();
    }
    document.addEventListener('shopify:section:unload', onUnload);
    function queue() {
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame || setTimeout)(function () { queued = false; update(); });
    }
    wIn.addEventListener('input', queue);
    jIn.addEventListener('input', queue);
    update();
    if (window.ResizeObserver) {
      var lastW = svg.clientWidth;
      ro = new ResizeObserver(function () {
        var w = svg.clientWidth;
        if (st && w !== lastW) { lastW = w; hide(); draw(root, st); }
      });
      ro.observe(svg);
    }
  }

  var count = 0;
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tridos-bbc]:not([data-tridos-bbc-ready])'), function (root) {
      root.setAttribute('data-tridos-bbc-ready', '');
      setup(root, ++count);
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
});

/* 060 — Our own cookie banner (snippets/tridos-consent-banner.liquid). Replaces the Avada
   app, which had stopped drawing anything (2026-10-23: no banner at all, so every EU/UK
   visitor stayed "no answer" and no tracker could see them).
   Shopify's Customer Privacy API decides who sees it (shouldShowBanner: the regions set
   in admin → Customer privacy) and stores the answer in its own cookie. Every tracker
   reads that answer: Meta, Google, Shopify analytics, and PostHog 030 through the
   'visitorConsentCollected' event Shopify fires after setTrackingConsent().
   localStorage 'tridos_cc_force' = '1' shows it outside those regions too (the 060 spec;
   the CI runner is in the US). */
tridosBlock('060', function () {
  var root = document.querySelector('[data-tridos-cc]');
  if (!root || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
  var prefs = root.querySelector('[data-cc-prefs]');
  var settingsBtn = root.querySelector('[data-cc="settings"]');
  var cp = null;
  var opener = null;

  function forced() {
    try { return localStorage.getItem('tridos_cc_force') === '1'; } catch (err) { return false; }
  }

  // Forced mode only: outside the banner regions Shopify may store a default answer by
  // itself (seen on the US CI runner), so there "answered" means "answered in this bar".
  function markAnswered() {
    if (!forced()) return;
    try { localStorage.setItem('tridos_cc_answered', '1'); } catch (err) {}
  }
  function answeredHere() {
    try { return localStorage.getItem('tridos_cc_answered') === '1'; } catch (err) { return false; }
  }

  // '' = not answered, 'yes' / 'no' after an answer.
  function current() {
    try {
      var c = cp && typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      return c || {};
    } catch (err) {
      return {};
    }
  }

  function showPrefs(on) {
    prefs.hidden = !on;
    settingsBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  // The ticks follow the stored answer each time the bar opens (not each time Settings
  // is toggled, which would drop ticks the visitor set but has not saved yet).
  // `ticks` (after a failed save): the choice the visitor tried to save, kept for a retry.
  function show(withPrefs, ticks) {
    var c = current();
    Array.prototype.forEach.call(prefs.querySelectorAll('[data-cc-opt]'), function (box) {
      var kind = box.getAttribute('data-cc-opt');
      box.checked = ticks ? !!ticks[kind] : c[kind] === 'yes';
    });
    root.hidden = false;
    showPrefs(!!withPrefs);
  }

  function hide() {
    root.hidden = true;
    showPrefs(false);
    if (opener && document.contains(opener)) {
      try { opener.focus(); } catch (err) {}
    }
    opener = null;
  }

  // One write at a time: an answer given while an earlier one is still being saved waits
  // and goes last, so the visitor's latest answer is the one Shopify keeps. A failed write
  // brings the bar back, so the visitor can try again (review round 1, Sol).
  var saving = false;
  var queued = null;
  function write(choice) {
    if (saving) { queued = choice; return; }
    saving = true;
    cp.setTrackingConsent({
      analytics: choice.analytics,
      marketing: choice.marketing,
      preferences: choice.analytics,
      sale_of_data: choice.marketing
    }, function (res) {
      saving = false;
      if (queued) {
        var next = queued;
        queued = null;
        write(next);
        return;
      }
      if (res && res.error) {
        if (window.console) console.error('[custom.js 060]', res.error);
        show(choice.fromPrefs, choice);
      }
    });
  }

  // Hidden at once, so the tap feels instant; Shopify's cookie is written in the background.
  function answer(analytics, marketing, fromPrefs) {
    hide();
    markAnswered();
    if (!cp || typeof cp.setTrackingConsent !== 'function') return;
    write({ analytics: analytics, marketing: marketing, fromPrefs: !!fromPrefs });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc]');
    if (!btn) return;
    var what = btn.getAttribute('data-cc');
    if (what === 'accept') answer(true, true);
    else if (what === 'reject') answer(false, false);
    else if (what === 'settings') {
      // The tick boxes sit before Settings in the page: move focus to them when they open.
      var opening = prefs.hidden;
      showPrefs(opening);
      if (opening) prefs.querySelector('[data-cc-opt]').focus();
    } else if (what === 'save') {
      answer(
        !!prefs.querySelector('[data-cc-opt="analytics"]').checked,
        !!prefs.querySelector('[data-cc-opt="marketing"]').checked,
        true
      );
    }
  });

  // A visitor who already answered and opened the bar again to look may close it with
  // Escape. A first-time visitor has to answer.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden && current().analytics) hide();
  });

  // "Cookie settings" anywhere on the shop: a link to #cookie-settings (footer menu) on
  // this page or the home page. Ctrl/Cmd/middle clicks and links to other pages behave as
  // normal links; the bar opens there from the hash.
  var ready = false;
  var failed = false;
  var pending = false;
  function openSettings(from) {
    opener = from || null;
    show(true);
    var first = root.querySelector('[data-cc-opt]');
    if (first) first.focus();
  }
  function dropHash() {
    if (window.location.hash !== '#cookie-settings') return;
    try { history.replaceState(history.state, '', window.location.pathname + window.location.search); } catch (err) {}
  }
  document.addEventListener('click', function (e) {
    if (failed || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.hash !== '#cookie-settings') return;
    if (a.pathname !== window.location.pathname && a.pathname !== '/') return;
    e.preventDefault();
    if (ready) openSettings(a);
    else pending = true;
  });
  window.addEventListener('hashchange', function () {
    if (window.location.hash !== '#cookie-settings' || !ready) return;
    dropHash();
    openSettings(null);
  });

  // Starts once the Privacy API is there. Three ways in, whichever comes first: the
  // loadFeatures callback, the API's own 'consentTrackingApiLoaded' event, and a check
  // every 250 ms for 15 s. The callback alone was not enough: 030 asks the same loader
  // earlier, and in 4 of 36 test runs the API was loaded but this callback never came.
  function boot() {
    if (ready) return;
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.currentVisitorConsent !== 'function' || typeof api.setTrackingConsent !== 'function') return;
    cp = api;
    ready = true;
    failed = false;
    if (pending || window.location.hash === '#cookie-settings') {
      dropHash();
      openSettings(null);
      return;
    }
    if (forced()) {
      if (!answeredHere()) show(false);
      return;
    }
    var needed = false;
    try { needed = typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner(); } catch (err2) {}
    if (needed && !current().analytics) show(false);
  }

  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { boot(); });
  document.addEventListener('consentTrackingApiLoaded', boot);
  window.addEventListener('consentTrackingApiLoaded', boot);
  var tries = 0;
  var poll = setInterval(function () {
    boot();
    tries += 1;
    if (ready || tries >= 60) {
      clearInterval(poll);
      // No API after 15 s: settings links go back to being plain links.
      if (!ready) failed = true;
    }
  }, 250);
});
